import React, { Fragment } from 'react';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import axios from 'axios';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import LocationMap from '../tools/LocationMap';
import * as ETVConstants from '../ETVConstants';
import MessageDialog from '../tools/MessageDialog';
import { Autocomplete, Divider, InputLabel, Paper } from '@mui/material';
import { RestartAlt, Upload } from '@mui/icons-material';


const DEFAULT_LAYOUT_BY_TYPE = {
  weather: '1_1',
  weather5: '4_3',
  time1: 'raster',
  time2: '16_9',
  time3: '4_3',
  time3V2: 'raster',
  arrow: '1_1',
  tripcounter: '1_1',
  qrcode: '1_1',
  floornumber: '1_1',
  next_stop: '1_1',
  next_stop_2: '16_9',
  next_stop_3: '16_9',
  next_stop_list: '4_3',
  next_stop_list_2: 'raster',
  door: '4_3',
  floor_directory: '3_4',
  floor_directory_noscrolling: '4_3',
  remote_elevator_view: '4_3',
  kone_dcs_queue_message_view: '16_9',
  elevator_touch_button: '3_4',
  elevator_touch_button_10: '3_4',
  elevator_touch_button_scrolling: '3_4',
  floorpics: '4_3',
  statictext: 'raster',
  speed:'1.5_1',
  speed2:'1_1',
  height:'1.5_1',
  height2:'1_6'
};

const BASIC_LAYOUT_OPTIONS = [
  { value: "1_1", label: ETVConstants.trans("square") },
  { value: "4_3", label: ETVConstants.trans("4_3") },
  { value: "freestyle", label: ETVConstants.trans("freestyle") },
  { value: "raster", label: ETVConstants.trans("raster") },
];

const WIDE_LAYOUT_OPTIONS = [
  { value: "16_9", label: ETVConstants.trans("16_9") },
  { value: "freestyle", label: ETVConstants.trans("freestyle") },
  { value: "raster", label: ETVConstants.trans("raster") },
];

const LIST_LAYOUT_OPTIONS = [
  { value: "1_1", label: ETVConstants.trans("square") },
  { value: "4_3", label: ETVConstants.trans("4_3") },
  { value: "freestyle", label: ETVConstants.trans("freestyle") },
  { value: "raster", label: ETVConstants.trans("raster") },
];


class LayoutDesigner extends React.Component {

    constructor(props) {
      super(props);
      this.onMouseOut = this.onMouseOut.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onMouseMove = this.onMouseMove.bind(this);
      this.setLocationGPS = this.setLocationGPS.bind(this);
      this.loadBG = this.loadBG.bind(this);
      this.readerBGImageLoaded = this.readerBGImageLoaded.bind(this);
      this.bgImageLoaded = this.bgImageLoaded.bind(this);
      this.closeInfoMessage = this.closeInfoMessage.bind(this);
    }

    state = {
      devices:[],     
      isLoaded:false,
      border: 20,
      items:[],
      canvas:undefined,
      ctx:undefined,
      cWidth:600,
      cHeight:450,
      canvasResolution:1.33334,
      needRedraw: true,
      raster_size: 10,
      startPos: undefined,
      endPos: undefined,
      currentMousePos: undefined,
      channelLayout: "4_3",
      curChannel:0,
      curEmpty:0,
      curStreaming:0,
      curElevFrag:0,
      curTimeFrag1Lines:0,
      curTimeFrag2Lines:0,
      curTimeFrag3Lines:0,
      curTimeFrag3LinesV2:0,
      qr_code:'',
      curQRCodeFrag:0,
      curArrowFrag:0,
      remote_elevator_id:0,
      remote_elevator_txt:'',
      remote_elevator_ip:'',
      cur_kone_queue_msg_frag:0,
      curRemoteElevatorFrag:0,
      curDoorFrag:0,
      nof_lines:3,
      curFloorNrFrag:0,
      curNextStopFrag:0,
      curNextStopFrag2:0,
      curNextStopFrag3:0,
      curNextStopListFrag:0,
      curNextStopListFrag2:0,
      floors:"",
      highlight_color:'#aabbcc',
      curFloorDirFrag:0,
      curTouchButtonFrag:0,
      curTouchButtonFrag10:0,
      curTouchButtonFragScrolling:0,
      touch_button_type:0,
      curFloorDirNoScrollingFrag:0,
      curWeatherFrag:0,
      curWeather5Frag:0,
      curHeightFrag:0,
      curHeightFrag2:0,
      height_title:"CURRENT HEIGHT",
      height_icon_color:"",
      curSpeedFrag:0,
      curSpeed2Frag:0,
      speed_title:'CURRENT SPEED',
      needle_color:"",
      customer_title_color:"",
      max_speed:10.0,
      curFloorPicFrag:0,
      curTripCounterFrag:0,
      curStaticTxtFrag:0,
      static_txt_line_1:'',
      finalImage:undefined,
      finalConfigFile:undefined,
      isSubmitting:false,
      channel_type:'content',
      content_rounded_corner: 0,
      streaming_ip:'',
      streaming_backup:'',
      streaming_ip_supervision:'',
      clock_format:'hh:mm a',
      clock_date_format:'1',
      widget_text_color:'',
      widget_background:'full_transparent',
      clock_locale:'en',
      weather_city_lat:'',
      weather_city_lgt:'',
      weather_city_name:'',
      weather_units:"celsius",
      error_message:undefined,
      bg_color: "#000000",
      isLandscape: true,
      debug: false,
      canvas_bg:undefined,
      canvas_img:undefined,
    }

    componentDidMount() {
      const canvas = this.refs.canvas;
      const ctx = canvas.getContext("2d");
      this.setState({ ctx, canvas, needRedraw: true }, () => {
        this.drawCanvasContent();
        this.loadItems();
      });
    }

    componentDidUpdate(prevProps, prevState) {
      // redraw only when explicitly requested
      if (this.state.needRedraw && (prevState.needRedraw !== this.state.needRedraw)) {
        this.drawCanvasContent();
      }

      // submit only on the transition "finalImage became available"
      if (this.state.finalImage && !this.state.isSubmitting && prevState.finalImage !== this.state.finalImage) {
        this.submitLayout();
      }
    }

    loadItems() {
      var accessToken = localStorage.getItem("etv.access_token");
      var reqUserID = localStorage.getItem("etv.user_id");
      var url = ETVConstants.getServerBase()+"/device_mgmt?action=list&owner_id="+this.props.user_id;
        fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then(
          (result) => {
            //console.log("dfsdfsfsafafsaf="+result);
            var dev = this.sortDeviceList(result.list);
            this.setState({
              devices: dev,
              isLoaded: true,
            });
          },
          (error) => {
            this.setState({
            devices:[],
            isLoaded: false,
            error
            });
          }
        )
    }

    sortDeviceList( arr) {
      if(!arr || arr.length==0) return [];
      arr.sort((a, b) => {
        return a.device_name.toLowerCase().localeCompare(b.device_name.toLowerCase());
      });
      return arr;
    }

    showWindow(divID, show) {
      show?this.setState({window:divID}):this.setState({window:''});
    }

    showInfoMessage(title,msg,isSpinning) {
      this.setState({window:'message_div',info_type:'info',info_title:title,info_message:msg,spinning:isSpinning});
    }

    showSuccessMessage(title,msg) {
        this.setState({window:'message_div',info_type:'success',info_title:title,info_message:msg,spinning:false});
    }

    showErrorMessage(title,msg) {
        this.setState({window:'message_div',info_type:'error',info_title:title,info_message:msg,spinning:false});
    }

    closeInfoMessage() {
      this.setState({window:'',info_type:'',info_title:'',info_message:undefined,spinning:false});
    }

    // check if the rectangle pos0 -> pos1 intersects with other rectangles
    rectsOverlap(a0, a1, b0, b1) {
      const ax0 = Math.min(a0.x, a1.x), ax1 = Math.max(a0.x, a1.x);
      const ay0 = Math.min(a0.y, a1.y), ay1 = Math.max(a0.y, a1.y);
      const bx0 = Math.min(b0.x, b1.x), bx1 = Math.max(b0.x, b1.x);
      const by0 = Math.min(b0.y, b1.y), by1 = Math.max(b0.y, b1.y);

      // overlap if projections overlap on both axes
      return ax0 < bx1 && ax1 > bx0 && ay0 < by1 && ay1 > by0;
    }

    intersectWithOthers(pos0, pos1) {
      if (!this.state.items || this.state.items.length === 0) return false;
      for (let i = 0; i < this.state.items.length; i++) {
        const item = this.state.items[i];
        if (this.rectsOverlap(pos0, pos1, item.startPos, item.endPos)) return true;
      }
      return false;
    }


    isInside( pos0, pos1, point) {
      //console.log("xxxxxxxxxxx point="+point);
      return (point.x > pos0.x) && (point.x < pos1.x) && (point.y > pos0.y) && (point.y < pos1.y);
    }

    checkConsistencyChannel( channel) {
      return (channel.startPos.x < channel.endPos.x) && (channel.startPos.y < channel.endPos.y);
    }

    createChannel( name, startPos, endPos, parameter) {
      //console.log("createChannel, name="+name);
      if(startPos.x > endPos.x) {
        var temp = startPos;
        startPos = endPos;
        endPos = temp;
      }

      if(!this.intersectWithOthers(startPos,endPos)) {
          var o = {};
          o.name = name;
          if (o.name.startsWith("content")) {
            var curChannel = this.state.curChannel;
            o.name = o.name+curChannel;
            o.id = "Channel"+curChannel+"Fragment";
            o.channelColor = this.getChannelColor(curChannel);
            o.content_rounded_corner = this.state.content_rounded_corner;
            curChannel++;
            this.setState({curChannel:curChannel});
            if(curChannel>4) {
              this.setState({channel_type:''});
            }

          }else if(o.name.startsWith("empty")) {
            var curEmpty = this.state.curEmpty;
            /// state has not broadcastet, therefore use parameter field!!!
            o.id = "EmptyChannel_"+parameter;
            if(this.state.debug) {
              o.channelColor = "#FF44FF";
              o.name = o.id;
            }else{
              o.channelColor = "#000000";
            }
            curEmpty++;
            this.setState({curEmpty:curEmpty});

          }else if(o.name.startsWith("streaming")){
            var curStreaming = this.state.curStreaming;
            if(!this.state.streaming_ip) {
              this.showErrorMessage("please enter the streaming address");
              return undefined;
            }
            o.name = o.name+" ("+this.state.streaming_ip+")";
            o.id = "StreamingFragment_"+curStreaming;
            o.channelColor = "#b32758";
            curStreaming++;
            o.streaming_ip = this.state.streaming_ip;
            o.streaming_backup = this.state.streaming_backup;
            o.streaming_ip_supervision = this.state.streaming_ip_supervision;
            o.parameter = parameter;
            this.setState({curStreaming:curStreaming});

          }else if(o.name.startsWith("elevator_landscape")){
            //console.log("creating elevator frame");
            var curElevFrag = this.state.curElevFrag;
            o.name = o.name+" "+curElevFrag;
            o.id = "ElevatorArrowFragmentLandscape_"+curElevFrag;
            o.channelColor = "#ccdd33";
            curElevFrag++;
            this.setState({curElevFrag:curElevFrag});
            if(curElevFrag>1) {
              this.setState({channel_type:'content'});
            }

          }else if(o.name.startsWith("elevator_portrait")){
            //console.log("creating elevator frame");
            var curElevFrag2 = this.state.curElevFrag;
            o.name = o.name+" "+curElevFrag2;
            o.id = "ElevatorArrowFragmentPortrait_"+curElevFrag2;
            o.channelColor = "#ccdd33";
            curElevFrag2++;
            this.setState({curElevFrag:curElevFrag2});
            if(curElevFrag2>1) {
              this.setState({channel_type:'content'});
            }

          }else if(o.name.startsWith("elevator_small")){
            //console.log("creating elevator small fragement");
            var curElevFrag3 = this.state.curElevFrag;
            o.name = o.name+" "+curElevFrag3;
            o.id = "ElevatorArrowFragmentSmall_"+curElevFrag3;
            o.channelColor = "#ccdd33";
            curElevFrag3++;
            this.setState({curElevFrag:curElevFrag3});
            if(curElevFrag3>1) {
              this.setState({channel_type:'content'});
            }

          }else if(o.name.startsWith("qrcode")){
            var curQR = this.state.qr_code;
            if(!this.state.qr_code) {
              this.showErrorMessage("please enter a qr code in the text field");
              return undefined;
            }
            var curQRCodeFrag = this.state.curQRCodeFrag;
            o.id = "QRCodeFragment_"+curQRCodeFrag;
            o.qr_code = curQR;
            o.channelColor = "#535353";
            o.widget_text_color = this.state.widget_text_color;
            o.widget_background = this.state.widget_background;
            curQRCodeFrag++;
            this.setState({curQRCodeFrag:curQRCodeFrag});

          }else if(o.name.startsWith("arrow")){
            var curArrowFrag1 = this.state.curArrowFrag;
            o.id = "ArrowFragment_"+curArrowFrag1;
            o.channelColor = "#442299";
            o.widget_background = this.state.widget_background;
            curArrowFrag1++;
            this.setState({curArrowFrag:curArrowFrag1});

          }else if(o.name.startsWith("door")){
            var curDoorFrag1 = this.state.curDoorFrag;
            o.id = "DoorFragment_"+curDoorFrag1;
            o.channelColor = "#992299";
            o.widget_background = this.state.widget_background;
            curDoorFrag1++;
            this.setState({curDoorFrag:curDoorFrag1});

          }else if(o.name.startsWith("floornumber")){
            var curFloorNrFrag1 = this.state.curFloorNrFrag;
            o.id = "FloorNumberFragment_"+curFloorNrFrag1;
            o.channelColor = "#992299";
            o.widget_background = this.state.widget_background;
            o.widget_text_color = this.state.widget_text_color;
            curFloorNrFrag1++;
            this.setState({curFloorNrFrag:curFloorNrFrag1});

          } else if (o.name.startsWith("next_stop_list_2")) {
            let idx = this.state.curNextStopListFrag2;
            o.id = "NextStopListFragment2_" + idx;
            o.channelColor = "#999922";
            o.widget_background = this.state.widget_background;
            o.widget_text_color = this.state.widget_text_color;
            o.floors = this.state.floors;
            o.highlight_color = this.state.highlight_color;
            idx++;
            this.setState({ curNextStopListFrag2: idx });

          } else if (o.name.startsWith("next_stop_list")) {
            let idx = this.state.curNextStopListFrag;
            o.id = "NextStopListFragment_" + idx;
            o.channelColor = "#229999";
            o.widget_background = this.state.widget_background;
            o.widget_text_color = this.state.widget_text_color;
            idx++;
            this.setState({ curNextStopListFrag: idx });

          }else if(o.name.startsWith("next_stop_3")){
            var curNextStopFrag11 = this.state.curNextStopFrag3;
            o.id = "NextStopFragment3_"+curNextStopFrag11;
            o.channelColor = "#332299";
            o.widget_background = this.state.widget_background;
            curNextStopFrag11++;
            this.setState({curNextStopFrag3:curNextStopFrag11});

          }else if(o.name.startsWith("next_stop_2")){
            var curNextStopFrag12 = this.state.curNextStopFrag2;
            o.id = "NextStopFragment2_"+curNextStopFrag12;
            o.channelColor = "#336699";
            o.widget_background = this.state.widget_background;
            curNextStopFrag12++;
            this.setState({curNextStopFrag2:curNextStopFrag12});

          }else if(o.name.startsWith("next_stop")){
            var curNextStopFrag1 = this.state.curNextStopFrag;
            o.id = "NextStopFragment_"+curNextStopFrag1;
            o.channelColor = "#229999";
            o.widget_background = this.state.widget_background;
            curNextStopFrag1++;
            this.setState({curNextStopFrag:curNextStopFrag1});

          }else if(o.name.startsWith("remote_elevator_view")){
            if(!this.state.remote_elevator_id || !this.state.remote_elevator_txt) {
              this.showErrorMessage("enter a elevator text and id");
              return undefined;
            }
            var curRemoteElevatorFrag1 = this.state.curRemoteElevatorFrag;
            o.id = "RemoteElevatorFragment_"+curRemoteElevatorFrag1;
            o.channelColor = "#557799";
            o.widget_background = this.state.widget_background;
            o.remote_elevator_id = this.state.remote_elevator_id;
            o.remote_elevator_txt = this.state.remote_elevator_txt;
            o.remote_elevator_ip = this.state.remote_elevator_ip;
            curRemoteElevatorFrag1++;
            this.setState({curRemoteElevatorFrag:curRemoteElevatorFrag1});

          }else if(o.name.startsWith("kone_dcs_queue_message_view")){
            var cur_frag = this.state.cur_kone_queue_msg_frag;
            o.id = "KONE_DCS_QueueMessageFragment_"+cur_frag;
            o.channelColor = "#441100";
            o.widget_background = this.state.widget_background;
            cur_frag++;
            this.setState({cur_kone_queue_msg_frag:cur_frag});

          }else if(o.name.startsWith("floor_directory_noscrolling")){
            var curFloorDirNoScrollingFrag1 = this.state.curFloorDirNoScrollingFrag;
            o.id = "FloorDirectoryNoScrollingFragment_"+curFloorDirNoScrollingFrag1;
            o.channelColor = "#660033";
            o.nof_lines = this.state.nof_lines;
            o.widget_text_color = this.state.widget_text_color;
            o.widget_background = this.state.widget_background;
            curFloorDirNoScrollingFrag1++;
            this.setState({curFloorDirNoScrollingFrag:curFloorDirNoScrollingFrag1});

          }else if(o.name.startsWith("floor_directory")){
            var curFloorDirFrag1 = this.state.curFloorDirFrag;
            o.id = "FloorDirectoryFragment_"+curFloorDirFrag1;
            o.widget_text_color = this.state.widget_text_color;
            o.nof_lines = this.state.nof_lines;
            o.channelColor = "#66FF33";
            o.widget_background = this.state.widget_background;
            curFloorDirFrag1++;
            this.setState({curFloorDirFrag:curFloorDirFrag1});

          }else if(o.name.startsWith("elevator_touch_button_scrolling")){
            var curTouchButtonFrag1 = this.state.curTouchButtonFragScrolling;
            o.id = "ElevatorTouchButtonFragmentScrolling_"+curTouchButtonFrag1;
            o.widget_text_color = this.state.widget_text_color;
            o.touch_button_type = this.state.touch_button_type;
            o.channelColor = "#434402ff";
            o.widget_background = this.state.widget_background;
            curTouchButtonFrag1++;
            this.setState({curTouchButtonFragScrolling:curTouchButtonFrag1});

          }else if(o.name.startsWith("elevator_touch_button_10")){
            var curTouchButtonFrag12 = this.state.curTouchButtonFrag10;
            o.id = "ElevatorTouchButtonFragment10_"+curTouchButtonFrag12;
            o.widget_text_color = this.state.widget_text_color;
            o.touch_button_type = this.state.touch_button_type;
            o.channelColor = "#5f6106ff";
            o.widget_background = this.state.widget_background;
            curTouchButtonFrag12++;
            this.setState({curTouchButtonFrag10:curTouchButtonFrag12});

          }else if(o.name.startsWith("elevator_touch_button")){
            var curTouchButtonFrag13 = this.state.curTouchButtonFrag;
            o.id = "ElevatorTouchButtonFragment_"+curTouchButtonFrag13;
            o.widget_text_color = this.state.widget_text_color;
            o.touch_button_type = this.state.touch_button_type;
            o.channelColor = "#bb7d0bff";
            o.widget_background = this.state.widget_background;
            curTouchButtonFrag13++;
            this.setState({curTouchButtonFrag:curTouchButtonFrag13});

          }else if(o.name.startsWith("time1")){
            var curTimeFrag1Line = this.state.curTimeFrag1Lines;
            o.id = "TimeFragment1Lines_"+curTimeFrag1Line;
            o.channelColor = "#777777";
            o.clock_format = this.state.clock_format;
            o.clock_date_format = this.state.clock_date_format;
            o.widget_text_color = this.state.widget_text_color;
            o.widget_background = this.state.widget_background;
            o.clock_locale = this.state.clock_locale;
            curTimeFrag1Line++;
            this.setState({curTimeFrag1Lines:curTimeFrag1Line});

          }else if(o.name.startsWith("time2")){
            var curTimeFrag2Lines = this.state.curTimeFrag2Lines;
            o.id = "TimeFragment2Lines_"+curTimeFrag2Lines;
            o.channelColor = "#777777";
            o.clock_format = this.state.clock_format;
            o.clock_date_format = this.state.clock_date_format;
            o.widget_text_color = this.state.widget_text_color;
            o.widget_background = this.state.widget_background;
            o.clock_locale = this.state.clock_locale;
            curTimeFrag2Lines++;
            this.setState({curTimeFrag2Lines:curTimeFrag2Lines});

          }else if(o.name.startsWith("time3V2")){
            var curTimeFrag3LinesV2 = this.state.curTimeFrag3LinesV2;
            o.id = "TimeFragment3LinesVariant2_"+curTimeFrag3LinesV2;
            o.channelColor = "#777777";
            o.clock_format = this.state.clock_format;
            o.clock_date_format = this.state.clock_date_format;
            o.widget_text_color = this.state.widget_text_color;
            o.widget_background = this.state.widget_background;
            o.clock_locale = this.state.clock_locale;
            curTimeFrag3LinesV2++;
            this.setState({curTimeFrag3LinesV2:curTimeFrag3LinesV2});

          }else if(o.name.startsWith("time3")){
            var curTimeFrag3Lines = this.state.curTimeFrag3Lines;
            o.id = "TimeFragment3Lines_"+curTimeFrag3Lines;
            o.channelColor = "#777777";
            o.clock_format = this.state.clock_format;
            o.clock_date_format = this.state.clock_date_format;
            o.widget_text_color = this.state.widget_text_color;
            o.widget_background = this.state.widget_background;
            o.clock_locale = this.state.clock_locale;
            curTimeFrag3Lines++;
            this.setState({curTimeFrag3Lines:curTimeFrag3Lines});

          }else if(o.name.startsWith("weather5")) {
            var curWeather5Frag = this.state.curWeather5Frag;
            o.id = "Weather5Fragment_"+curWeather5Frag;
            o.channelColor = "#f5b042";
            o.widget_background = this.state.widget_background;
            o.weather_city_lat = this.state.weather_city_lat;
            o.weather_city_lgt = this.state.weather_city_lgt;
            o.weather_city_name = this.state.weather_city_name;
            o.widget_text_color = this.state.widget_text_color;
            o.weather_units = this.state.weather_units;
            curWeather5Frag++;
            this.setState({curWeather5Frag:curWeather5Frag});

          }else if(o.name.startsWith("weather")) {
            var curWeatherFrag = this.state.curWeatherFrag;
            o.id = "WeatherFragment_"+curWeatherFrag;
            o.channelColor = "#f5b042";
            o.weather_city_lat = this.state.weather_city_lat;
            o.weather_city_lgt = this.state.weather_city_lgt;
            o.weather_city_name = this.state.weather_city_name;
            o.widget_background = this.state.widget_background;
            o.widget_text_color = this.state.widget_text_color;
            o.weather_units = this.state.weather_units;
            curWeatherFrag++;
            this.setState({curWeatherFrag:curWeatherFrag});

          }else if(o.name.startsWith("speed2")) {
            var curSpeedFrag12 = this.state.curSpeedFrag2;
            o.id = "SpeedFragment2_"+curSpeedFrag1;
            o.channelColor = "#f54287";
            o.speed_title = this.state.speed_title;
            o.needle_color = this.state.needle_color;
            o.max_speed = this.state.max_speed;
            o.widget_background = this.state.widget_background;
            o.widget_text_color = this.state.widget_text_color;
            curSpeedFrag12++;
            this.setState({curSpeedFrag2:curSpeedFrag12});            

          }else if(o.name.startsWith("speed")) {
            var curSpeedFrag1 = this.state.curSpeedFrag;
            o.id = "SpeedFragment_"+curSpeedFrag1;
            o.channelColor = "#f54287";
            o.speed_title = this.state.speed_title;
            o.custom_title_color = this.state.custom_title_color;
            o.max_speed = this.state.max_speed;
            o.widget_background = this.state.widget_background;
            o.widget_text_color = this.state.widget_text_color;
            curSpeedFrag1++;
            this.setState({curSpeedFrag:curSpeedFrag1});            

          }else if(o.name.startsWith("height2")) {
            var curHeightFrag12 = this.state.curHeightFrag2;
            o.id = "HeightFragment2_"+curHeightFrag1;
            o.channelColor = "#027715";
            o.height_title = this.state.height_title;
            o.widget_background = this.state.widget_background;
            o.widget_text_color = this.state.widget_text_color;
            o.height_icon_color = this.state.height_icon_color;
            curHeightFrag12++;
            this.setState({curHeightFrag2:curHeightFrag12});            

          }else if(o.name.startsWith("height")) {
            var curHeightFrag1 = this.state.curHeightFrag;
            o.id = "HeightFragment_"+curHeightFrag1;
            o.channelColor = "#728b02";
            o.height_title = this.state.height_title;
            o.widget_background = this.state.widget_background;
            o.widget_text_color = this.state.widget_text_color;
            o.height_icon_color = this.state.height_icon_color;
            curHeightFrag1++;
            this.setState({curHeightFrag:curHeightFrag1});            

          }else if(o.name.startsWith("floorpics")) {
            var curFloorPicFrag = this.state.curFloorPicFrag;
            o.id = "ElevatorFloorPicFragment_"+curFloorPicFrag;
            o.channelColor = "#21d1cb";
            curFloorPicFrag++;
            this.setState({curFloorPicFrag:curFloorPicFrag});

          }else if(o.name.startsWith("tripcounter")) {
            var curTripCounterFrag = this.state.curTripCounterFrag;
            o.id = "ElevatorTripCounterFragment_"+curTripCounterFrag;
            o.channelColor = "#d10fce";
            o.widget_background = this.state.widget_background;
            o.widget_text_color = this.state.widget_text_color;
            curTripCounterFrag++;
            this.setState({curTripCounterFrag:curTripCounterFrag});

          }else if(o.name.startsWith("statictext")) {
            var curStaticTxtFrag = this.state.curStaticTxtFrag;
            o.id = "StaticTextFragment_"+curStaticTxtFrag;
            o.channelColor = "#ffab43";
            o.static_txt_line_1 = this.state.static_txt_line_1;
            o.widget_background = this.state.widget_background;
            o.widget_text_color = this.state.widget_text_color;
            curStaticTxtFrag++;
            this.setState({curStaticTxtFrag:curStaticTxtFrag});
          }
          o.startPos = startPos;
          o.endPos = endPos;
          o.alignLeft = false;
          o.rightOf = null;
          o.alignTop = false;
          o.belowOf = null;
          o.isLastRight = false;
          o.isLastBottom = false;
          return o;
      }else{
        return undefined;
      }
    }

    drawLine(x0, y0, x1, y1) {
      const ctx = this.state.ctx;
      if (!ctx) return;
      ctx.beginPath();
      ctx.moveTo(x0, y0);
      ctx.lineTo(x1, y1);
      ctx.stroke();
    }

    adjustInsideBorder( pos) {
      if(!this.state.canvas) return pos;
      var border = this.state.border;

      var resX = pos.x;
      var resY = pos.y;
      if(resX<border) {
        resX = border;
      }
      if((resX+border)>this.state.canvas.width) {
        //console.log("outside maxWidth");
        resX = this.state.canvas.width-border;
      }
      if (resY<border) {
        //console.log("y < border");
        resY = border;
      }
      if(resY>this.state.canvas.height-border) {
        //console.log("Y > border")
        resY = this.state.canvas.height-border;
      }
      return {x:resX,y:resY};
    }

    drawRaster() {
      const ctx = this.state.ctx;
      const canvas = this.state.canvas;
      if (!ctx || !canvas) return;
      const b0 = this.state.border;
      const stepWidth = this.state.raster_size;
      ctx.save();
      // force a known-good state (prevents “vanishing”)
      ctx.globalAlpha = 1;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      // border
      this.drawRectangle(
        { x: b0, y: b0 },
        { x: canvas.width - b0, y: canvas.height - b0 },
        1,
        "#000000",
        ""
      );
      // light grid
      ctx.strokeStyle = "#F0F0F0";
      ctx.lineWidth = 0.5;
      let nofSteps = (canvas.width - 2 * b0) / stepWidth;
      for (let i = 0; i <= nofSteps; i++) {
        this.drawLine(b0 + i * stepWidth, b0, b0 + i * stepWidth, canvas.height - b0);
      }
      nofSteps = (canvas.height - 2 * b0) / stepWidth;
      for (let i = 0; i <= nofSteps; i++) {
        this.drawLine(b0, b0 + i * stepWidth, canvas.width - b0, b0 + i * stepWidth);
      }
      // helper lines
      ctx.strokeStyle = "#00FF00";
      ctx.lineWidth = 0.6;
      const xLines = this.getXLines(this.state.items);
      for (let i = 1; i < xLines.length - 1; i++) {
        this.drawLine(xLines[i], b0, xLines[i], canvas.height - b0);
      }
      const yLines = this.getYLines(this.state.items);
      for (let i = 1; i < yLines.length - 1; i++) {
        this.drawLine(b0, yLines[i], canvas.width - b0, yLines[i]);
      }
      ctx.restore();
    }


    roundDecimal(num) {
      return Math.round(num * 100) / 100;
    }

    drawCanvasContent() {
      const { ctx, canvas } = this.state;
      if (!ctx || !canvas) return;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // bg
      if (this.state.canvas_img) {
        const b0 = this.state.border;
        this.drawImageCover(
          ctx,
          this.state.canvas_img,
          b0,
          b0,
          canvas.width - 2 * b0,
          canvas.height - 2 * b0
        );
      }

      // handle pending rectangle creation (keep as-is)
      if (this.state.startPos && this.state.endPos) {
        const c = this.createChannel(this.state.channel_type + " ", this.state.startPos, this.state.endPos, null);
        if (c) {
          const newItems = [...this.state.items, c];
          this.setState({ items: newItems, startPos: undefined, endPos: undefined, needRedraw: false });
          return;
        } else {
          this.setState({ endPos: undefined, needRedraw: false });
          return;
        }
      }

      // preview while dragging (draw BEFORE channels or AFTER, your choice)
      if (this.state.startPos) {
        this.drawCircle(this.state.startPos, 6, "#FF0000");
        const adjust = this.adjustMousePos(this.state.currentMousePos);
        const txt = `(${this.roundDecimal(adjust.x - this.state.startPos.x)} / ${this.roundDecimal(adjust.y - this.state.startPos.y)})`;
        this.drawRectangle(this.state.startPos, adjust, 1, "#FF0000", txt);
      }

      this.drawRaster();
      for (let i = 0; i < this.state.items.length; i++) {
        const channel = this.state.items[i];
        if (!channel) continue;

        if (channel.name === "empty" || (channel.name && channel.name.startsWith("empty"))) {
          this.fillRectangle(channel.startPos, channel.endPos, channel.channelColor, "");
        } else {
          this.fillRectangle(channel.startPos, channel.endPos, channel.channelColor, channel.name);
        }
      }
      if (this.state.currentMousePos) this.drawMousePosition(this.state.currentMousePos);
      if (this.state.needRedraw) this.setState({ needRedraw: false });
    }

    // Draw an image into a fixed rectangle without changing the selected layout size.
    // The image is scaled proportionally and only the minimum excess is center-cropped.
    drawImageCover(ctx, image, x, y, width, height) {
      if (!ctx || !image || !image.width || !image.height || width <= 0 || height <= 0) {
        return;
      }

      const sourceRatio = image.width / image.height;
      const targetRatio = width / height;
      let sourceX = 0;
      let sourceY = 0;
      let sourceWidth = image.width;
      let sourceHeight = image.height;

      if (sourceRatio > targetRatio) {
        sourceWidth = image.height * targetRatio;
        sourceX = (image.width - sourceWidth) / 2;
      } else if (sourceRatio < targetRatio) {
        sourceHeight = image.width / targetRatio;
        sourceY = (image.height - sourceHeight) / 2;
      }

      ctx.drawImage(
        image,
        sourceX,
        sourceY,
        sourceWidth,
        sourceHeight,
        x,
        y,
        width,
        height
      );
    }

    distance( p0, p1) {
      var dX = p1.x - p0.x;
      var dY = p1.y - p0.y;
      return Math.sqrt( dX*dX + dY*dY);
    }

    findNearestPoint( point, points) {
       var closestP = points[0];
       var closestD = this.distance(point,points[0]);
       for(var i=1; i<points.length; i++) {
          var dist = this.distance(point,points[i]);
          if(dist<closestD) {
            closestD = dist;
            closestP = points[i];
          }
       }
       return closestP;
    }

    getChannelPoints( channel) {
      // counter clockwise
      var p0 = channel.startPos;
      var p2 = channel.endPos;
      var p1 = {x:p2.x,y:p0.y};
      var p3 = {x:p0.x,y:p2.y};
      return [p0,p1,p2,p3];
    }

    avoidInsideChannelStartPos( coord) {
      if(!this.state.items || this.state.items.length===0) {
        return coord;
      }
      for(var i=0; i<this.state.items.length; i++) {
        var item = this.state.items[i];
        if(this.isInside(item.startPos,item.endPos,coord)) {
          // remark +1 pixel
          // allocated nearest points
          var channelPoints = this.getChannelPoints(item);
          //console.log("ChannelPoints="+channelPoints);
          var closestP = this.findNearestPoint( coord, channelPoints);
          if(closestP===channelPoints[0]) {
              return {x:closestP.x,y:closestP.y};

          }else if(closestP===channelPoints[1]) {
              return {x:closestP.x+1,y:closestP.y};

          }else if(closestP===channelPoints[2]) {
              return {x:closestP.x+1,y:closestP.y};

          }else if(closestP===channelPoints[3]) {
              return {x:closestP.x,y:closestP.y};
          }
          return closestP;
          //coord = {x:item.endPos.x+1,y:item.startPos.y};
        }
      }
      return coord;
    }

    handleCanvasClick = (evt) => {

      if(this.state.channel_type==='') {
          this.showErrorMessage(ETVConstants.trans("please_choose_channel_type"));
          return;
      }

      if(this.state.channel_type==='streaming' && (!this.state.streaming_ip || this.state.streaming_ip==='')) {
        this.showErrorMessage(ETVConstants.trans("please_set_ip_streaming_address"));
        return;
      }
      if(this.state.channel_type==='weather5' || this.state.channel_type==='weather') {
        if(!this.state.weather_city_lat || !this.state.weather_city_lgt) {
            this.showErrorMessage(ETVConstants.trans("please_set_location"));
            return;
        }
      }
      if(this.state.channel_type==='statictext') {
        if(!this.state.static_txt_line_1) {
            this.showErrorMessage(ETVConstants.trans("please_enter_text"));
            return;
        }
      }
      if(this.state.channel_type==='qrcode') {
        if(!this.state.qr_code) {
            this.showErrorMessage(ETVConstants.trans("please_enter_qr_code"));
            return;
        }
      }
      const coord0 = this.getMousePos(this.state.canvas,evt);
      const coord1 = this.adjustMousePos(coord0);
      const coord = this.avoidInsideChannelStartPos(coord1);
      if(!this.state.startPos) {
        this.setState({startPos:coord});
      }else{
        this.setState({endPos:coord});
      }
    }

    getMousePos(canvas, evt) {
        var rect = this.state.canvas.getBoundingClientRect();
        return {
          x: evt.clientX - rect.left,
          y: evt.clientY - rect.top
        };
    }

    onMouseMove(evt) {
      var rect = this.state.canvas.getBoundingClientRect();
      var x = evt.clientX - rect.left;
      var y = evt.clientY - rect.top;
      var curPos = {x:x,y:y};
      this.setState({currentMousePos:curPos, needRedraw:true});
    }

    roundTo( x, z) {
      var mod = x % z;
      if(mod<=(z/2)) {
        return x-mod;
      }else{
        return x-mod+z;
      }
    }

    findStartPoint( pos) {
      var roundedtoLineX = false;
      var roundedtoLineY = false;

      var testX = Math.max(pos.x,this.state.border);
      testX = Math.min(pos.x,this.state.canvas.width-this.state.border);
      var xLines = this.getXLines(this.state.items);
      for( var i=0; i<xLines.length; i++) {
        if(Math.abs(xLines[i]-testX)<5) {
          testX = xLines[i];
          roundedtoLineX = true;
        }
      }
      var testY = Math.max(pos.y,this.state.border);
      testY = Math.min(pos.y,this.state.canvas.height-this.state.border);
      var yLines = this.getYLines(this.state.items);
      for(i=0; i<yLines.length; i++) {
        if(Math.abs(yLines[i]-testY)<5) {
          testY = yLines[i];
          roundedtoLineY = true;
        }
      }
      if (!roundedtoLineX) {
        testX = this.roundTo(pos.x,this.state.raster_size);
        testX = Math.max(this.state.border,testX);
        testX = Math.min(this.state.canvas.width-this.state.border,testX);
      }
      if(!roundedtoLineY) {
        testY = this.roundTo(pos.y,this.state.raster_size);
        testY = Math.max(this.state.border,testY);
        testY = Math.min(this.state.canvas.height-this.state.border,testY);
      }
      return {x:testX,y:testY};
    }

    //ensures that we keep the ratio of outside border (even mouse goes out)
    ensureRatio(startPos, targetEnd, ratio) {
        var xNew = this.ensureXRange(targetEnd.x);
        if(xNew!==targetEnd.x) {
          var deltaX = xNew - startPos.x;
          var yNew = startPos.y + 1.0/ratio*deltaX;
          var res1 = {x:xNew,y:yNew};
          return res1;
        }
        var yNew1 = this.ensureYRange(targetEnd.y);
        if(yNew1!==targetEnd.y) {
          var deltaY = startPos.y - yNew1;
          var xNew1 = startPos.x - ratio*deltaY;
          var res2 = {x:xNew1,y:yNew1};
          return res2;
        }
        return targetEnd;
    }

    ensureXRange( x) {
      if (x<this.state.border) return this.state.border;
      if (x>(this.state.canvas.width - this.state.border)) {return (this.state.canvas.width-this.state.border);}
      return x;
    }

    ensureYRange( y) {
      if (y<this.state.border) return this.state.border;
      if (y>(this.state.canvas.height - this.state.border)) return (this.state.canvas.height-this.state.border);
      return y;
    }

    adjustMousePos( pos0) {
      var pos = this.adjustInsideBorder(pos0);
      var x = pos.x;
      var y = pos.y;
      if(!this.state.startPos) {
          var startPos = this.findStartPoint(pos0);
          return {x:startPos.x,y:startPos.y};
      }
      var deltaX = 0;
      //console.log(this.state.channelLayout);
      if(this.state.channelLayout==='raster') {
          x = this.roundTo(pos.x,this.state.raster_size);
          y = this.roundTo(pos.y,this.state.raster_size);
          return {x:x,y:y};

      }else if(this.state.channelLayout==='4_3') {
          deltaX = pos.x - this.state.startPos.x;
          y = this.state.startPos.y + deltaX*0.75;
          if(y>this.state.canvas.height-this.state.border) {
            y = this.state.canvas.height-this.state.border;
            x = this.state.startPos.x + (y-this.state.startPos.y)*1.333333;
          }
          return this.ensureRatio(this.state.startPos,{x:x,y:y},1.333);

      }else if(this.state.channelLayout==='3_4') {
          deltaX = pos.x - this.state.startPos.x;
          y = this.state.startPos.y + 1.33333*deltaX;
          if(y>this.state.canvas.height-this.state.border) {
            y = this.state.canvas.height-this.state.border;
            x = this.state.startPos.x + (y-this.state.startPos.y)*0.75;
          }
          return this.ensureRatio(this.state.startPos,{x:x,y:y},0.75);

      }else if(this.state.channelLayout==='5_4') {
          deltaX = pos.x - this.state.startPos.x;
          y = this.state.startPos.y + deltaX*0.8;
          if(y>this.state.canvas.height-this.state.border) {
            y = this.state.canvas.height-this.state.border;
            x = this.state.startPos.x + (y-this.state.startPos.y)*1.25;
          }
          return this.ensureRatio(this.state.startPos,{x:x,y:y},1.25);

      }else if(this.state.channelLayout==='4_5') {
          deltaX = pos.x - this.state.startPos.x;
          y = this.state.startPos.y + 1.25*deltaX;
          if(y>this.state.canvas.height-this.state.border) {
            y = this.state.canvas.height-this.state.border;
            x = this.state.startPos.x + (y-this.state.startPos.y)*0.8;
          }
          return this.ensureRatio(this.state.startPos,{x:x,y:y},0.8);

      }else if(this.state.channelLayout==='191_1') {
          deltaX = pos.x - this.state.startPos.x;
          y = this.state.startPos.y + 0.52356*deltaX;
          if(y>this.state.canvas.height-this.state.border) {
            y = this.state.canvas.height-this.state.border;
            x = this.state.startPos.x + (y-this.state.startPos.y)*1.91;
          }
          return this.ensureRatio(this.state.startPos,{x:x,y:y},1.91);

      }else if(this.state.channelLayout==='16_9') {
          deltaX = pos.x - this.state.startPos.x;
          y = this.state.startPos.y + 0.5625*deltaX;
          if(y>this.state.canvas.height-this.state.border) {
            y = this.state.canvas.height-this.state.border;
            x = this.state.startPos.x + (y-this.state.startPos.y)*1.77777778;
          }
          return this.ensureRatio(this.state.startPos,{x:x,y:y},1.7777778);


      }else if(this.state.channelLayout==='9_16') {
          deltaX = pos.x - this.state.startPos.x;
          y = this.state.startPos.y + 1.77777778*deltaX;
          if(y>this.state.canvas.height-this.state.border) {
            y = this.state.canvas.height-this.state.border;
            x = this.state.startPos.x + (y-this.state.startPos.y)*0.5625;
          }
          return this.ensureRatio(this.state.startPos,{x:x,y:y},0.5625);

      }else if(this.state.channelLayout==='2_1') {
          deltaX = pos.x - this.state.startPos.x;
          y = this.state.startPos.y + 0.5*deltaX;
          if(y>this.state.canvas.height-this.state.border) {
            y = this.state.canvas.height-this.state.border;
            x = this.state.startPos.x + (y-this.state.startPos.y)*2.0;
          }
          return this.ensureRatio(this.state.startPos,{x:x,y:y},2.0);

      }else if(this.state.channelLayout==='1.5_1') {
          deltaX = pos.x - this.state.startPos.x;
          y = this.state.startPos.y + 0.66667*deltaX;
          if(y>this.state.canvas.height-this.state.border) {
            y = this.state.canvas.height-this.state.border;
            x = this.state.startPos.x + (y-this.state.startPos.y)*1.5;
          }
          return this.ensureRatio(this.state.startPos,{x:x,y:y},1.5);

      }else if(this.state.channelLayout==='3_1') {
          deltaX = pos.x - this.state.startPos.x;
          y = this.state.startPos.y + 0.3333*deltaX;
          if(y>this.state.canvas.height-this.state.border) {
            y = this.state.canvas.height-this.state.border;
            x = this.state.startPos.x + (y-this.state.startPos.y)*3.0;
          }
          return this.ensureRatio(this.state.startPos,{x:x,y:y},3.0);

      }else if(this.state.channelLayout==='2.5_1') {
          deltaX = pos.x - this.state.startPos.x;
          y = this.state.startPos.y + 0.4*deltaX;
          if(y>this.state.canvas.height-this.state.border) {
            y = this.state.canvas.height-this.state.border;
            x = this.state.startPos.x + (y-this.state.startPos.y)*2.5;
          }
          return this.ensureRatio(this.state.startPos,{x:x,y:y},2.5);

      }else if(this.state.channelLayout==='2.2_1') {
          deltaX = pos.x - this.state.startPos.x;
          y = this.state.startPos.y + 0.454545*deltaX;
          if(y>this.state.canvas.height-this.state.border) {
            y = this.state.canvas.height-this.state.border;
            x = this.state.startPos.x + (y-this.state.startPos.y)*2.2;
          }
          return this.ensureRatio(this.state.startPos,{x:x,y:y},2.2);

      }else if(this.state.channelLayout==='1_6') {
          deltaX = pos.x - this.state.startPos.x;
          y = this.state.startPos.y + 6*deltaX;
          if(y>this.state.canvas.height-this.state.border) {
            y = this.state.canvas.height-this.state.border;
            x = this.state.startPos.x + (y-this.state.startPos.y)*0.16667;
          }
          return this.ensureRatio(this.state.startPos,{x:x,y:y},6.0);

      }else if(this.state.channelLayout==='banner') {
            deltaX = pos.x - this.state.startPos.x;
            y = this.state.startPos.y + (1.0/7.8)*deltaX;
            if(y>this.state.canvas.height-this.state.border) {
              y = this.state.canvas.height-this.state.border;
              x = this.state.startPos.x + (y-this.state.startPos.y)*7.8;
            }
            return this.ensureRatio(this.state.startPos,{x:x,y:y},7.8);

      }else if(this.state.channelLayout==='leaderboard') {
            deltaX = pos.x - this.state.startPos.x;
            y = this.state.startPos.y + (1.0/8.0888889)*deltaX;
            if(y>this.state.canvas.height-this.state.border) {
                y = this.state.canvas.height-this.state.border;
                x = this.state.startPos.x + (y-this.state.startPos.y)*8.0888889;
            }
            return this.ensureRatio(this.state.startPos,{x:x,y:y},8.0888889);

      }else if(this.state.channelLayout==='inline_rectangle') {
            deltaX = pos.x - this.state.startPos.x;
            y = this.state.startPos.y + (1.0/1.2)*deltaX;
            if(y>this.state.canvas.height-this.state.border) {
                y = this.state.canvas.height-this.state.border;
                x = this.state.startPos.x + (y-this.state.startPos.y)*1.2;
            }
            return this.ensureRatio(this.state.startPos,{x:x,y:y},1.2);

      }else if(this.state.channelLayout==='skyscraper') {
            deltaX = pos.x - this.state.startPos.x;
            y = this.state.startPos.y + (1.0/0.2)*deltaX;
            if(y>this.state.canvas.height-this.state.border) {
                y = this.state.canvas.height-this.state.border;
                x = this.state.startPos.x + (y-this.state.startPos.y)*0.2;
            }
            return this.ensureRatio(this.state.startPos,{x:x,y:y},0.2);

      }else if(this.state.channelLayout==='half_page_ad') {
            deltaX = pos.x - this.state.startPos.x;
            y = this.state.startPos.y + (1.0/0.5)*deltaX;
            if(y>this.state.canvas.height-this.state.border) {
                  y = this.state.canvas.height-this.state.border;
                  x = this.state.startPos.x + (y-this.state.startPos.y)*0.5;
            }
            return this.ensureRatio(this.state.startPos,{x:x,y:y},0.5);

      }else if(this.state.channelLayout==='large_leaderboard') {
            deltaX = pos.x - this.state.startPos.x;
            y = this.state.startPos.y + (1.0/10.77777778)*deltaX;
            if(y>this.state.canvas.height-this.state.border) {
                    y = this.state.canvas.height-this.state.border;
                    x = this.state.startPos.x + (y-this.state.startPos.y)*10.77777778;
            }
            return this.ensureRatio(this.state.startPos,{x:x,y:y},10.7777778);

      }else if(this.state.channelLayout==='1_1') {
            deltaX = pos.x - this.state.startPos.x;
            y = this.state.startPos.y + deltaX;
            if(y>this.state.canvas.height-this.state.border) {
              y = this.state.canvas.height-this.state.border;
              x = this.state.startPos.x + (y-this.state.startPos.y)*1;
            }
            return this.ensureRatio(this.state.startPos,{x:x,y:y},1.0);
      }
      // freeStyle --> get close to xYlines
      var testX = Math.max(x,this.state.border);
      testX = Math.min(x,this.state.canvas.width-this.state.border);
      var xLines = this.getXLines(this.state.items);
      for( var i=0; i<xLines.length; i++) {
        if(Math.abs(xLines[i]-testX)<5) {
          testX = xLines[i];
        }
      }
      var testY = Math.max(y,this.state.border);
      testY = Math.min(y,this.state.canvas.height-this.state.border);
      var yLines = this.getYLines(this.state.items);
      for(i=0; i<yLines.length; i++) {
        if(Math.abs(yLines[i]-testY)<5) {
          testY = yLines[i];
        }
      }
      return {x:this.ensureXRange(testX),y:this.ensureYRange(testY)};
    }

    drawMousePosition( mousePos) {
        var pos = this.adjustMousePos(mousePos);
        this.drawCircle(pos,4,"#222222");
    }

    drawRectangle(pos0, pos1, lineWidth, color, text) {
      const ctx = this.state.ctx;
      if (!ctx) return;
      const x0 = pos0.x, y0 = pos0.y;
      const x1 = pos1.x, y1 = pos1.y;
      ctx.save();
      // ensure numeric lineWidth (strings can behave weirdly on some browsers)
      ctx.lineWidth = Number(lineWidth) || 1;
      ctx.strokeStyle = color;
      ctx.beginPath();
      ctx.moveTo(x0, y0);
      ctx.lineTo(x1, y0);
      ctx.lineTo(x1, y1);
      ctx.lineTo(x0, y1);
      ctx.closePath();
      ctx.stroke();
      if (text && text.length > 0) {
        ctx.font = "14px Arial";
        ctx.fillStyle = "#000000";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        const cx = (x0 + x1) / 2;
        const cy = (y0 + y1) / 2;
        ctx.fillText(text, cx, cy);
      }
      ctx.restore();
    }


    fillRectangle(pos0, pos1, bgColor, text) {
      const ctx = this.state.ctx;
      if (!ctx) return;

      const x0 = pos0.x, y0 = pos0.y;
      const x1 = pos1.x, y1 = pos1.y;
      const w = x1 - x0, h = y1 - y0;

      ctx.save();

      // opaque background (raster will NOT be visible through)
      ctx.fillStyle = bgColor;
      ctx.fillRect(x0, y0, w, h);

      if (text && text.length > 0 && text !== "empty") {
        let fontSize = 20;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        ctx.font = `${fontSize}px Arial`;
        while (ctx.measureText(text).width > (w - 8) && fontSize > 8) {
          fontSize -= 2;
          ctx.font = `${fontSize}px Arial`;
        }

        ctx.fillStyle = "white";
        ctx.fillText(text, x0 + w / 2, y0 + h / 2);
      }

      ctx.restore();
    }

    getChannelColor( channelNr) {
      if(channelNr===0) {
        return "#276fe3";
      }else if(channelNr===1) {
        return "#03a631";
      }else if(channelNr===2) {
        return "#fa4343";
      }else if(channelNr===3) {
          return "#ff0066";
      }else if(channelNr===4) {
            return "#cc66ff";
      }else{
        return "#cc3300";
      }
    }

    drawCircle( pos, radius, color) {
        var x1 = pos.x;
        var y1 = pos.y;
        var ctx = this.state.ctx;
        ctx.beginPath();
        ctx.lineWidth=1;
        ctx.strokeStyle=color;
        ctx.arc(x1, y1, radius, 0, 2 * Math.PI);
        ctx.stroke();
    }

    handleCanvasResolutionChange = (event) => {
      const border = this.state.border;
      const ratio = parseFloat(event.target.value);
      let x, y, isLandscape;
    
      if (ratio >= 1) {
        // Landscape mode — limit width to 1500
        isLandscape = true;
        x = 1000;
        y = x / ratio;
      } else {
        // Portrait mode — minimum width 800
        isLandscape = false;
        x = 600;
        y = x / ratio;
      }
    
      // Add border
      const canvasWidth = x + 2 * border;
      const canvasHeight = y + 2 * border;
    
      // Reset and update state
      this.clearChannels();
      this.setState({
        canvasResolution: ratio,
        isLandscape: isLandscape,
        cWidth: canvasWidth,
        cHeight: canvasHeight,
        canvas_img: undefined,
        canvas_bg: undefined,
        needRedraw: true,
      });
    };

    onMouseOut() {
    }

    onKeyDown(event) {
      //console.log("KeyDown keyValue="+event.keyCode+" event.key="+event.key);
      //var ch = event.key;
      if(this.state.status===1) {
        //console.log("append char="+ch);
      }else{
        //console.log("ouf of focus, not append char ("+ch+")");
      }
    }

    convertCanvasToImageData(canvas) {
      const border = this.state.border;
      const cWidth = canvas.width;
      const cHeight = canvas.height;
      const cropped = this.crop(
        canvas,
        { x: border, y: border },
        { x: cWidth - border, y: cHeight - border }
      );
      const out = document.createElement("canvas");
      out.width = cropped.width;
      out.height = cropped.height;
      const ctx = out.getContext("2d");
      ctx.fillStyle = "#000000";
      ctx.fillRect(0, 0, out.width, out.height);
      ctx.drawImage(cropped, 0, 0);
      return out.toDataURL("image/png");
    }


    crop(can, a, b) {
      // get your canvas and a context for it
      var ctx = can.getContext('2d');
      // get the image data you want to keep.
      var imageData = ctx.getImageData(a.x, a.y, b.x, b.y);
      // create a new cavnas same as clipped size and a context
      var newCan = document.createElement('canvas');
      newCan.width = b.x - a.x;
      newCan.height = b.y - a.y;
      var newCtx = newCan.getContext('2d');
      // put the clipped image on the new canvas.
      newCtx.putImageData(imageData, 0, 0);
      return newCan;
    }

    prepareSubmitLayout(txt) {
      var imageData = this.convertCanvasToImageData(this.state.canvas);
      this.setState({finalImage:imageData,finalConfigFile:txt});
    }

    submitLayout() {
      this.setState({isSubmitting:true});
      this.showInfoMessage(ETVConstants.trans("uploading..."), "", true);

      var formData = new FormData();
      formData.append("user_id",this.props.user_id);
      formData.append("layout_image",this.state.finalImage);
      formData.append("layout_data",this.state.finalConfigFile);
      formData.append("nof_channels",this.state.curChannel);
      formData.append("screen_ratio",this.state.canvasResolution);
      formData.append("landscape",this.state.isLandscape);

      const config = {
        headers: {	'content-type': 'multipart/form-data'}
      }
      var url = ETVConstants.getServerBase()+"/layout_upload";
      axios.post(url, formData, config)
            .then((response) => {
                  this.showSuccessMessage(ETVConstants.trans("successfully_uploaded"));
                  this.clearChannels();
                  this.setState({finalImage:undefined,finalConfigFile:undefined,isSubmitting:false});
                })
                .catch((error) => {
                   this.showErrorMessage(ETVConstants.trans("uploading_error"));
                   this.setState({finalImage:undefined,finalConfigFile:undefined,isSubmitting:false});
                });
    }

    stepBack() {
      if (this.state.startPos) {
        this.setState({ startPos: undefined, endPos: undefined, needRedraw: true });
        return;
      }
      const curItems = [...this.state.items];
      const channel = curItems.pop();
      if (!channel) return;
      const s = {};
      if (channel.name.startsWith("content")) s.curChannel = Math.max(0, this.state.curChannel - 1);
      else if (channel.id.startsWith("TimeFragment1Lines_")) s.curTimeFrag1Lines = Math.max(0, this.state.curTimeFrag1Lines - 1);
      else if (channel.id.startsWith("TimeFragment2Lines_")) s.curTimeFrag2Lines = Math.max(0, this.state.curTimeFrag2Lines - 1);
      else if (channel.id.startsWith("TimeFragment3LinesV2_")) s.curTimeFrag3LinesV2 = Math.max(0, this.state.curTimeFrag3LinesV2 - 1);
      else if (channel.id.startsWith("TimeFragment3Lines_")) s.curTimeFrag3Lines = Math.max(0, this.state.curTimeFrag3Lines - 1);
      else if (channel.id.startsWith("QRCodeFragment_")) s.curQRCodeFrag = Math.max(0, this.state.curQRCodeFrag - 1);
      else if (channel.id.startsWith("ArrowFragment_")) s.curArrowFrag = Math.max(0, this.state.curArrowFrag - 1);
      else if (channel.id.startsWith("DoorFragment_")) s.curDoorFrag = Math.max(0, this.state.curDoorFrag - 1);
      else if (channel.id.startsWith("FloorNumberFragment_")) s.curFloorNrFrag = Math.max(0, this.state.curFloorNrFrag - 1);
      else if (channel.id.startsWith("NextStopListFragment2_")) s.curNextStopListFrag2 = Math.max(0, this.state.curNextStopListFrag2 - 1);
      else if (channel.id.startsWith("NextStopListFragment_")) s.curNextStopListFrag = Math.max(0, this.state.curNextStopListFrag - 1);
      else if (channel.id.startsWith("NextStopFragment3_")) s.curNextStopFrag3 = Math.max(0, this.state.curNextStopFrag3 - 1);
      else if (channel.id.startsWith("NextStopFragment2_")) s.curNextStopFrag2 = Math.max(0, this.state.curNextStopFrag2 - 1);
      else if (channel.id.startsWith("NextStopFragment_")) s.curNextStopFrag = Math.max(0, this.state.curNextStopFrag - 1);
      else if (channel.id.startsWith("RemoteElevatorFragment_")) s.curRemoteElevatorFrag = Math.max(0, this.state.curRemoteElevatorFrag - 1);
      else if (channel.id.startsWith("KONE_DCS_QueueMessageFragment_")) s.cur_kone_queue_msg_frag = Math.max(0, this.state.cur_kone_queue_msg_frag - 1);
      else if (channel.id.startsWith("FloorDirectoryNoScrollingFragment_")) s.curFloorDirNoScrollingFrag = Math.max(0, this.state.curFloorDirNoScrollingFrag - 1);
      else if (channel.id.startsWith("FloorDirectoryFragment_")) s.curFloorDirFrag = Math.max(0, this.state.curFloorDirFrag - 1);
      else if (channel.id.startsWith("ElevatorTouchButtonFragmentScrolling_")) s.curTouchButtonFragScrolling = Math.max(0, this.state.curTouchButtonFragScrolling - 1);
      else if (channel.id.startsWith("ElevatorTouchButtonFragment10_")) s.curTouchButtonFrag10 = Math.max(0, this.state.curTouchButtonFrag10 - 1);
      else if (channel.id.startsWith("ElevatorTouchButtonFragment_")) s.curTouchButtonFrag = Math.max(0, this.state.curTouchButtonFrag - 1);
      else if (channel.id.startsWith("Weather5Fragment_")) s.curWeather5Frag = Math.max(0, this.state.curWeather5Frag - 1);
      else if (channel.id.startsWith("WeatherFragment_")) s.curWeatherFrag = Math.max(0, this.state.curWeatherFrag - 1);
      else if (channel.id.startsWith("SpeedFragment_")) s.curSpeedFrag = Math.max(0, this.state.curSpeedFrag - 1);
      else if (channel.id.startsWith("SpeedFragment2_")) s.curSpeedFrag2 = Math.max(0, this.state.curSpeedFrag2 - 1);
      else if (channel.id.startsWith("HeightFragment_")) s.curHeightFrag = Math.max(0, this.state.curHeightFrag - 1);
      else if (channel.id.startsWith("ElevatorFloorPicFragment_")) s.curFloorPicFrag = Math.max(0, this.state.curFloorPicFrag - 1);
      else if (channel.id.startsWith("ElevatorTripCounterFragment_")) s.curTripCounterFrag = Math.max(0, this.state.curTripCounterFrag - 1);
      else if (channel.id.startsWith("StaticTextFragment_")) s.curStaticTxtFrag = Math.max(0, this.state.curStaticTxtFrag - 1);
      else if (channel.id.startsWith("ElevatorArrowFragment")) s.curElevFrag = Math.max(0, this.state.curElevFrag - 1);
      else if (channel.id.startsWith("StreamingFragment_")) s.curStreaming = Math.max(0, this.state.curStreaming - 1);
      this.setState({ items: curItems, ...s, needRedraw: true });
    }

    clearChannels() {
      this.setState({
        items: [],
        startPos: undefined,
        endPos: undefined,
        nof_lines: 3,
        curChannel: 0,
        curEmpty: 0,
        curStreaming: 0,
        curElevFrag: 0,
        curTimeFrag1Lines: 0,
        curTimeFrag2Lines: 0,
        curTimeFrag3Lines: 0,
        curTimeFrag3LinesV2: 0,
        curQRCodeFrag: 0,
        curArrowFrag: 0,
        curFloorNrFrag: 0,
        curNextStopFrag: 0,
        curNextStopFrag2: 0,
        curNextStopFrag3: 0,
        curNextStopListFrag: 0,
        curNextStopListFrag2: 0,
        curFloorDirFrag: 0,
        curFloorDirNoScrollingFrag: 0,
        curDoorFrag: 0,
        curWeatherFrag: 0,
        curWeather5Frag: 0,
        curSpeedFrag: 0,
        curSpeedFrag2: 0,
        curHeightFrag: 0,
        curFloorPicFrag: 0,
        curTripCounterFrag: 0,
        curStaticTxtFrag: 0,
        curRemoteElevatorFrag: 0,
        cur_kone_queue_msg_frag: 0,
        curTouchButtonFrag: 0,
        curTouchButtonFrag10: 0,
        curTouchButtonFragScrolling: 0,
        needRedraw: true
      });
    }

    checkChannelsSortingConsistency( channels) {
      //console.log("--------- <CHECK CONSISTENCY> ----------------");
      for(var i=1; i<channels.length; i++) {
        var consistent = this.checkChannelConsistent(channels[i-1],channels[i]);
        if(!consistent) {
          //console.log(channels[i-1].name+" / "+channels[i].name+" NOT CONSISTENT!!!!!!");
          return false;
        }else{
          this.printChannel(channels[i-1]);
          this.printChannel(channels[i]);
        }
      }
      //console.log("--------- </CHECK CONSISTENCY> ----------------");
      return true;
    }

    printChannel( channel) {
      //o.startPos = startPos;
      //o.endPos = endPos;
      //o.alignLeft = false;
      //o.rightOf = null;
      //o.alignTop = false;
      //o.belowOf = null;
      //o.isLastRight = false;
      //o.isLastBottom = false;
      console.log(channel.name+" x0="+channel.startPos.x+" x1="+channel.endPos.x+" y0="+channel.startPos.y+" y1="+channel.endPos.y+" rightOf="+channel.rightOf);
    }

    // checking if the channel is setup correctly
    channelOK( channel) {
      return channel.startPos.x < channel.endPos.x && channel.startPos.y < channel.endPos.y;
    }

    // checking if the channel0 and channel 1 are consistent with each other
    checkChannelConsistent( channel0, channel1) {
      if (!this.channelOK(channel0)) return false;
      if (!this.channelOK(channel1)) return false;
      if (channel0.startPos.y > channel1.startPos.y) return false;
      if (channel0.startPos.y === channel1.startPos.y && channel0.startPos.x >= channel1.startPos.x) return false;
      return true;
    }

    finalize() {
      var drawBuffer = this.state.items;
    	var generatedChannels = this.createAndSortChannelsWithEmpty(drawBuffer);
      var newItems = generatedChannels;
      this.sortChannelsY(newItems);
      // make sure the white channels are drawn to
      this.setState({needRedraw:true});
      //console.log("items.size="+newItems.length+" emptyChannels="+generatedChannels.length);
      this.setState({items:newItems,needRedraw:true});
    	this.assignTopLevels(newItems);
    	var txt = this.generateConfigFile(newItems);
      //console.log(txt);
    	if(this.state.debug) {
        console.log(txt);
      }
      this.drawCanvasContent();
      this.setState({needRedraw:true});
    	this.prepareSubmitLayout(txt);
    }

    needsElevatorConnection(channels) {
      for(var i=0; i<channels.length; i++) {
        var channelType = channels[i].name;
        if(channelType.startsWith("elevator_landscape")) return true;
        if(channelType.startsWith("elevator_portrait")) return true;
        if(channelType.startsWith("elevator_small")) return true;
        if(channelType.startsWith("floorpics")) return true;
        if(channelType.startsWith("tripcounter")) return true;
        if(channelType.startsWith("arrow")) return true;
        if(channelType.startsWith("door")) return true;
        if(channelType.startsWith("floornumber")) return true;
        if(channelType.startsWith("next_stop_list_2")) return true;
        if(channelType.startsWith("next_stop_list")) return true;
        if(channelType.startsWith("next_stop_3")) return true;
        if(channelType.startsWith("next_stop_2")) return true;
        if(channelType.startsWith("next_stop")) return true;
        if(channelType.startsWith("floor_directory_noscrolling")) return true;
        if(channelType.startsWith("floor_directory")) return true;
        if(channelType.startsWith("elevator_touch_button_scrolling")) return true;
        if(channelType.startsWith("elevator_touch_button_10")) return true;
        if(channelType.startsWith("elevator_touch_button")) return true;
        if(channelType.startsWith("kone_dcs_queue_message_view")) return true;
        //note: remote elevator view does not need a direct connection, its remote through network (and connects directly without Elevator Connection Class)
      }
      return false;
    }

    generateConfigFile( channels) {
      var hasElev = this.needsElevatorConnection(channels);
    	var res = "layout.background.color="+this.state.bg_color+"\r\n";
    	res+="layout.orientation="+this.getMode()+"\r\n";
    	res+="has_elevator_connection="+hasElev+"\r\n";
      res+="\r\n";
    	for( var i=0; i<channels.length; i++) {
    		res += this.generateChannelString(i,channels[i]);
    	}
      //console.log(res);
    	return res;
    }

    getMode() {
    	var res = {w:this.state.canvas.width,h:this.state.canvas.height};
    	if (res.w >= res.h) {
    		return "landscape";
    	}
    	return "portrait";
    }

    generateChannelString(curID, channel) {
      var res = "";
    	res+="layout.channel."+curID+".id="+channel.id+"\r\n";
    	res+="layout.channel."+curID+".margin=0\r\n";

    	if (channel.alignTop) {
    		res+="layout.channel."+curID+".parent_top="+channel.alignTop+"\r\n";
    	}else{
    		res+="layout.channel."+curID+".below="+channel.belowOf+"\r\n";
    	}

    	if( channel.alignLeft) {
    		res+="layout.channel."+curID+".parent_left="+channel.alignLeft+"\r\n";
    	}else{
    		res+="layout.channel."+curID+".right_of="+channel.rightOf+"\r\n";
    	}
    	if (channel.isLastRight) {
    		res+="layout.channel."+curID+".width=match_parent\r\n";
      }else{
    		var widthInt = Math.min(1.0,(channel.endPos.x - channel.startPos.x) / (this.state.canvas.width-2*this.state.border));
    		res+="layout.channel."+curID+".width="+widthInt+"*W\r\n";
    	}

    	var heightInt = Math.min(1.0,(channel.endPos.y - channel.startPos.y) / (this.state.canvas.height-2*this.state.border));
    	res+="layout.channel."+curID+".height="+heightInt+"*H\r\n";

      if(channel.name.startsWith('content')) {
        res+="layout.channel."+curID+".parameter.0="+(channel.content_rounded_corner>0?"rounded":"edge")+"\r\n";

      }else if(channel.name.startsWith('streaming')) {
        res+="layout.channel."+curID+".parameter.0="+channel.streaming_ip+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.streaming_backup+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.streaming_ip_supervision+"\r\n";

      }else if(channel.name.startsWith('qrcode')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.qr_code+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.widget_text_color+"\r\n";

      }else if(channel.name.startsWith('floornumber')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.widget_text_color+"\r\n";

      }else if(channel.name.startsWith('next_stop_list_2')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.widget_text_color+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.floors+"\r\n";
        res+="layout.channel."+curID+".parameter.3="+channel.highlight_color+"\r\n";

      }else if(channel.name.startsWith('next_stop_list')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.widget_text_color+"\r\n";

      }else if(channel.name.startsWith('next_stop_3')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.widget_text_color+"\r\n";

      }else if(channel.name.startsWith('next_stop_2')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.widget_text_color+"\r\n";

      }else if(channel.name.startsWith('next_stop')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.widget_text_color+"\r\n";

      }else if(channel.name.startsWith('floor_directory_noscrolling')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.widget_text_color+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.nof_lines+"\r\n";

      }else if(channel.name.startsWith('floor_directory')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.widget_text_color+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.nof_lines+"\r\n";

      }else if(channel.name.startsWith('elevator_touch_button_scrolling') || channel.name.startsWith('elevator_touch_button_10') || channel.name.startsWith('elevator_touch_button')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.widget_text_color+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.touch_button_type+"\r\n";

      }else if(channel.name.startsWith('arrow') || channel.name.startsWith('door')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";

      }else if(channel.name.startsWith('time1')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.clock_format+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.clock_date_format+"\r\n";
        res+="layout.channel."+curID+".parameter.3="+channel.clock_locale+"\r\n";
        res+="layout.channel."+curID+".parameter.4="+channel.widget_text_color+"\r\n";

      }else if(channel.name.startsWith('time2')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.clock_format+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.clock_date_format+"\r\n";
        res+="layout.channel."+curID+".parameter.3="+channel.clock_locale+"\r\n";
        res+="layout.channel."+curID+".parameter.4="+channel.widget_text_color+"\r\n";

      }else if(channel.name.startsWith('time3V2')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.clock_format+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.clock_date_format+"\r\n";
        res+="layout.channel."+curID+".parameter.3="+channel.clock_locale+"\r\n";
        res+="layout.channel."+curID+".parameter.4="+channel.widget_text_color+"\r\n";

      }else if(channel.name.startsWith('time3')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.clock_format+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.clock_date_format+"\r\n";
        res+="layout.channel."+curID+".parameter.3="+channel.clock_locale+"\r\n";
        res+="layout.channel."+curID+".parameter.4="+channel.widget_text_color+"\r\n";

      }else if(channel.name.startsWith('weather5')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.weather_city_lat+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.weather_city_lgt+"\r\n";
        res+="layout.channel."+curID+".parameter.3="+channel.weather_city_name+"\r\n";
        res+="layout.channel."+curID+".parameter.4="+channel.widget_text_color+"\r\n";
        res+="layout.channel."+curID+".parameter.5="+channel.weather_units+"\r\n";

      }else if(channel.name.startsWith('weather')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.weather_city_lat+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.weather_city_lgt+"\r\n";
        res+="layout.channel."+curID+".parameter.3="+channel.weather_city_name+"\r\n";
        res+="layout.channel."+curID+".parameter.4="+channel.widget_text_color+"\r\n";
        res+="layout.channel."+curID+".parameter.5="+channel.weather_units+"\r\n";

      }else if(channel.name.startsWith('speed2')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.widget_text_color+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.speed_title+"\r\n";
        res+="layout.channel."+curID+".parameter.3="+channel.needle_color+"\r\n";
        res+="layout.channel."+curID+".parameter.4="+channel.max_speed+"\r\n";

      }else if(channel.name.startsWith('speed')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.widget_text_color+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.speed_title+"\r\n";
        res+="layout.channel."+curID+".parameter.3="+channel.custom_title_color+"\r\n";
        res+="layout.channel."+curID+".parameter.4="+channel.max_speed+"\r\n";

      }else if(channel.name.startsWith('height2')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.widget_text_color+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.height_title+"\r\n";
        res+="layout.channel."+curID+".parameter.3="+channel.height_icon_color+"\r\n";

      }else if(channel.name.startsWith('height')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.widget_text_color+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.height_title+"\r\n";
        res+="layout.channel."+curID+".parameter.3="+channel.height_icon_color+"\r\n";

      }else if(channel.name.startsWith('floorpics')) {
        //no parameter

      }else if(channel.name.startsWith('tripcounter')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.widget_text_color+"\r\n";

      }else if(channel.name.startsWith('statictext')) {
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.static_txt_line_1+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.widget_text_color+"\r\n";

      }else if(channel.name.startsWith('remote_elevator_view')) {
        //param0: elevator text
		    //param1: elevator id (multicast listener)
		    //param2: ip-address (optional)
		    //param3: background
		    //param4: fixed color (optional)
        res+="layout.channel."+curID+".parameter.0="+channel.remote_elevator_txt+"\r\n";
        res+="layout.channel."+curID+".parameter.1="+channel.remote_elevator_id+"\r\n";
        res+="layout.channel."+curID+".parameter.2="+channel.remote_elevator_ip+"\r\n";
        res+="layout.channel."+curID+".parameter.3="+channel.widget_background+"\r\n";

      }else if(channel.name.startsWith('kone_dcs_queue_message_view')) {
		    //param0: background
        res+="layout.channel."+curID+".parameter.0="+channel.widget_background+"\r\n";        
      }
    	res+="\r\n";
    	return res;
    }

    /**
     * assigns either alignTop or below which channel
     * @param {*} channels 
     * @returns 
     */
    assignTopLevels(channels) {
    	this.sortChannelsY(channels);
    	var curY = channels[0].startPos.y;
    	var alignTop = true;

    	for(var k=0; k<channels.length; k++) {
    		var channel = channels[k];
    		if (channel.startPos.y !== curY) {
    			alignTop = false;
    			curY = channel.startPos.y;
    		}
    		if (alignTop) {
    			channel.alignTop = true;
    		}else{
    			channel.belowOf = this.findBelow(channel,channels);
    		}
    	}
    	return channels;
    }

    /**
     * 
     * @param {f} channel 
     * @param {*} channels 
     * @returns finds the channel of which the channel is below
     */
    findBelow(channel,channels) {
      var startY = channel.startPos.y;
      for(var i=0; i<channels.length; i++) {
        if(channels[i].endPos.y===startY) {
          return channels[i].id;
        }
      }
      return "";
    }

    sortChannelsX( sortable) {
    	sortable.sort(function(a, b) {
          if (a.startPos.x < b.startPos.x) {
    	    	  return -1;
    	    }else if(a.startPos.x > b.startPos.x){
    	    	  return 1;
    	    }else{
    	       // x is equal, compare y
        		if (a.startPos.y<=b.startPos.y) {
        	    	return -1;
        	  }else {
        	    	return 1;
        	  }
          }
    	});
    }

    sortChannelsY( sortable) {
    	sortable.sort(function(a, b) {
    	    if (a.startPos.y < b.startPos.y) {
    	    	return -1;
    	    }else if(a.startPos.y > b.startPos.y){
    	    	return 1;
    	    }else{
    	       // y is equal, sort by x
    		    if (a.startPos.x<=b.startPos.x) {
    	    	    return -1;
    	      }else{
    	    	    return 1;
    	      }
          }
    	});
    }

    // used for the automatic pointer position
    getXLines(channels) {
      var border = this.state.border;
    	var xLines = [];
    	xLines.push(border);
    	for(var i=0; i<channels.length; i++) {
    		var nextXCandidate = channels[i].startPos.x;
    		if (!xLines.includes(nextXCandidate)) {
    			xLines.push(nextXCandidate);
    		}
    		nextXCandidate = channels[i].endPos.x;
    		if (!xLines.includes(nextXCandidate)) {
    			xLines.push(nextXCandidate);
    		}
    	}
    	xLines.push(this.state.canvas.width-border);
    	xLines.sort(function(a, b){return a - b});
    	return xLines;
    }

    // returns the smallest y first
    getYLines( channels) {
      var border = this.state.border;
    	var yLines = [];
    	yLines.push(border);
    	for(var i=0; i<channels.length; i++) {
    		var nextYCandidate = channels[i].startPos.y;
    		if (!yLines.includes(nextYCandidate)) {
    			yLines.push(nextYCandidate);
    		}
    		nextYCandidate = channels[i].endPos.y;
    		if (!yLines.includes(nextYCandidate)) {
    			yLines.push(nextYCandidate);
    		}
    	}
    	yLines.push(this.state.canvas.height-border);
    	yLines.sort(function(a, b){return a - b});
    	return yLines;
    }

    // return true if this channel crosses y0,y1
    intersectChannel(channel,y0,y1) {
      if(channel.endPos.y <= y0) return false;
      if(channel.startPos.y >= y1) return false;
      return true;
    	//var notIntersect = (channel.endPos.y <= y0) || (channel.startPos.y >= y1);
    	//return !notIntersect;
    }


    // channels of intersections
    getXIntersectingChannels(channels, y0, y1) {
    	var resXChannels = [];
    	for(var i=0; i<channels.length; i++) {
    		if (this.intersectChannel(channels[i],y0,y1)) {
    			//var point = {x0:channels[i].x0,x1:channels[i].x1};
    			resXChannels.push(channels[i]);
    		}
    	}
    	this.sortChannelsX(resXChannels);
    	return resXChannels;
    }

    // sorting all channels and create empty channels between
    createAndSortChannelsWithEmpty( channels) {
      var emptyCnt = 0;
    	var res = [];
      var border = this.state.border;
    	var yLines = this.getYLines(channels);
      if(this.state.debug) {
        //console.log(yLines);
      }
      //console.log("Y LINES="+yLines);

    	// have all the YLINES (smallest first)
    	for(var k=0; k<yLines.length-1; k++) {
    		var xIntersectingChannels = this.getXIntersectingChannels(channels, yLines[k], yLines[k+1]);
        if(this.state.debug) {
          //console.log("intersecting channels for y0="+yLines[k]+" y1="+yLines[k+1]+" :"+xIntersectingChannels.length);
        }
    		//assertSortedX(xIntersectingChannels);
    		if (xIntersectingChannels.length===0) {
          // full width, no channel intersects
    			var t0 = {x:border,y:yLines[k]};
    			var t1 = {x:this.state.canvas.width-border,y:yLines[k+1]};
    			var newChannel = this.createChannel("empty",t0,t1,emptyCnt++);
    			newChannel.alignLeft = true;
    			newChannel.isLastRight = true;
          //avoid 0 width 0 height channels
          const w = Math.abs(newChannel.endPos.x - newChannel.startPos.x);
          const h = Math.abs(newChannel.endPos.y - newChannel.startPos.y);
          if (w > 0 && h > 0) {
            res.push(newChannel);
          }
   			
    		}else{
          // scan from border through all the channels
    			var prevX = border;
    			var nextRightOfID = null;
          var y0 = yLines[k]; // top y
          var y1 = yLines[k+1]; // lower y of horizontal scan

    			for(var j=0; j<xIntersectingChannels.length; j++) {
            var curX = xIntersectingChannels[j].startPos.x;
    				var t0 = {x:prevX, y:y0};
    				var t1 = {x:curX,y:y1};

            if(prevX < curX) {
              // add an empty channel
              var addChannel = this.createChannel("empty",t0,t1,emptyCnt++);
              if (nextRightOfID==null) {
    						addChannel.alignLeft=true;
    					}else{
    						addChannel.rightOf=nextRightOfID;
    					}
              nextRightOfID = addChannel.id;
              if (xIntersectingChannels[j].rightOf==null) {
                xIntersectingChannels[j].rightOf = nextRightOfID;
              }
              nextRightOfID = xIntersectingChannels[j].id;
    					//console.log("push "+addChannel.id);
    					res.push( addChannel );
    					if(!this.existsChannelInArray(res,xIntersectingChannels[j].id)) {
    						res.push( xIntersectingChannels[j]);
    					}
              prevX = xIntersectingChannels[j].endPos.x;
            }else{
              // no empty channel between
              if(prevX===border) {
                xIntersectingChannels[j].alignLeft=true;
              }else{
                if(xIntersectingChannels[j].rightOf==null) {
                  // only assign if not yet assigned!
                  xIntersectingChannels[j].rightOf = nextRightOfID;
                }
              }
              nextRightOfID = xIntersectingChannels[j].id;
              if(!this.existsChannelInArray(res,xIntersectingChannels[j].id)) {
    						//console.log("push "+xIntersectingChannels[j].id);
    						res.push(xIntersectingChannels[j]);
    					}
              prevX = xIntersectingChannels[j].endPos.x;
            }
    			}
    			// last one (if necessary)
    			var lastX0 = xIntersectingChannels[xIntersectingChannels.length-1].endPos.x;
    			var lastX1 = this.state.canvas.width-border;
    			if(lastX0<lastX1) {
    				var ta0 = {x:lastX0, y:yLines[k]};
    				var ta1 = {x:lastX1, y:yLines[k+1]};
    				var lastChannel = this.createChannel("empty",ta0,ta1,emptyCnt++);
    				lastChannel.rightOf = nextRightOfID;
    				lastChannel.isLastRight = true;
    				//console.log("push "+lastChannel.id);
    				res.push( lastChannel);
    			}else{
    				xIntersectingChannels[xIntersectingChannels.length-1].isLastRight=true;
    			}
    		}
    	}
    	return res;
    }

    existsChannelInArray(channels,channelID) {
    	for( var i=0; i<channels.length; i++) {
    		if (channels[i].id===channelID) return true;
    	}
    	return false;
    }

////////////////////////////////////////////////////////////////////////////////
// GPS Location
////////////////////////////////////////////////////////////////////////////////

  setLocationGPS( lat, lgt, cityName) {
    this.setState({weather_city_lat:lat,weather_city_lgt:lgt,weather_city_name:cityName,window:''});
  }

////////////////////////////////////////////////////////////////////////////////
// manage channel type changes
////////////////////////////////////////////////////////////////////////////////

    handleChannelTypeChange(value) {
      const channelType = typeof value === "string" ? value : "";
      const defaultLayout = DEFAULT_LAYOUT_BY_TYPE[channelType];

      this.setState({
        widget_background: 'full_transparent',
        widget_text_color: '',
        content_rounded_corner: channelType === 'content' ? this.state.content_rounded_corner : 0,
        channel_type: channelType,
        ...(defaultLayout ? { channelLayout: defaultLayout } : {}),
      });
    }

    transLabel(key, fallback) {
      const translated = ETVConstants.trans(key);

      return {
        label: translated,
        searchLabel: typeof translated === "string" ? translated : fallback
      };
    }

////////////////////////////////////////////////////////////////////////////////
//
////////////////////////////////////////////////////////////////////////////////

    renderSimpleTypePanel({
      helpText,
      showWidgetBG = false,
      showTextColor = false,
      extraContent = null,
      layouts = [],
    }) {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          {helpText ? (
            <Typography
              style={{color:'gray', marginBottom:16}}
              component="div"
              gutterBottom
              variant="body2">
              {helpText}
            </Typography>
          ) : null}

          {extraContent ? (
            <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
              {extraContent}
            </Paper>
          ) : null}

          {showWidgetBG ? (
            <div style={{marginBottom:16}}>
              {this.printWidgetBGChoices()}
            </div>
          ) : null}

          {showTextColor ? (
            <div style={{marginBottom:16}}>
              {this.printWidgetTextColorChoices()}
            </div>
          ) : null}

          {layouts && layouts.length > 0 ? (
            <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
              <FormControl component="fieldset">
                <FormLabel component="legend">{ETVConstants.trans("channel_layout")}</FormLabel>

                <RadioGroup
                  aria-label="layout"
                  name="channelLayout"
                  value={this.state.channelLayout}
                  onChange={(e) => { this.setState({ channelLayout: e.target.value }) }}>

                  {layouts.map((layout) => (
                    <FormControlLabel
                      key={layout.value}
                      value={layout.value}
                      control={<Radio />}
                      label={layout.label}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Paper>
          ) : null}
        </Paper>
      );
    }

  printArrowType() {
    return this.renderSimpleTypePanel({
      helpText: ETVConstants.trans("arrow_help"),
      showWidgetBG: true,
      layouts: BASIC_LAYOUT_OPTIONS,
    });
  }

  printDoorType() {
    return this.renderSimpleTypePanel({
      helpText: ETVConstants.trans("door_help"),
      showWidgetBG: true,
      layouts: BASIC_LAYOUT_OPTIONS,
    });
  }  

  printFloorNumberType() {
    return this.renderSimpleTypePanel({
      helpText: ETVConstants.trans("floornumber_help"),
      showWidgetBG: true,
      showTextColor: true,
      layouts: BASIC_LAYOUT_OPTIONS,
    });
  }  

  printNextStopType() {
    return this.renderSimpleTypePanel({
      helpText: ETVConstants.trans("next_stop_help"),
      showWidgetBG: true,
      showTextColor: true,
      layouts: BASIC_LAYOUT_OPTIONS,
    });
  }

  printNextStop2Type() {
    return this.renderSimpleTypePanel({
      helpText: ETVConstants.trans("next_stop_help"),
      showWidgetBG: true,
      showTextColor: true,
      layouts: WIDE_LAYOUT_OPTIONS,
    });
  }

  printNextStop3Type() {
    return this.renderSimpleTypePanel({
      helpText: ETVConstants.trans("next_stop_help"),
      showWidgetBG: true,
      showTextColor: true,
      layouts: WIDE_LAYOUT_OPTIONS,
    });
  }

  printNextStopListType() {
    return this.renderSimpleTypePanel({
      helpText: ETVConstants.trans("next_stop_help"),
      showWidgetBG: true,
      showTextColor: true,
      layouts: LIST_LAYOUT_OPTIONS,
    });
  }

  printNextStopListType2() {
    return(
        <div style={{border:"1px solid lightgrey", backgroundColor:'#FDFDFD', marginRight:20, padding:10}}>
            <Typography style={{color:'gray'}} component={'span'} gutterBottom variant="body2" paragraph={true} >
                {ETVConstants.trans("next_stop_help")}
            </Typography>
            <br/><br/>
            <Divider style={{marginTop:5}}/>
            {this.printWidgetBGChoices()}
            <br/><br/>
            <Divider style={{marginTop:5}}/>
            {this.printWidgetTextColorChoices()}
            <br/><br/>
            <Divider style={{marginTop:5}}/>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("Floors")}</FormLabel>
              <Typography variant='body2'>Add the floors from bottom to top, separated by ";" e.g. GF;2;3;3A;5</Typography>
              <TextField style={{marginTop:5}} fullWidth size='small' label="floors" onChange={(e)=>{this.setState({floors:e.target.value})}} value={this.state.floors}/>
            </FormControl>
            <br/><br/>
            <Divider style={{marginTop:5}}/>
            {this.printWidgetTextHighlightChoices()}
            <br/><br/>
            <Divider style={{marginTop:5}}/>
            <FormControl component="fieldset">
                <FormLabel component="legend">{ETVConstants.trans("channel_layout")}</FormLabel>
                <RadioGroup aria-label="format" name="format1" value={this.state.channelLayout} onChange={(e) => {this.setState({channelLayout:e.target.value})}}>
                    <FormControlLabel value="freestyle" control={<Radio />} label={ETVConstants.trans("freestyle")} />
                    <FormControlLabel value="raster" control={<Radio />} label={ETVConstants.trans("raster")} />
                </RadioGroup>
            </FormControl>
        </div>
      );
  }

    printFloorDirectoryType() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("floor_directory_help")}
          </Typography>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            {this.printNofScrollingLines()}
          </Paper>

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("channel_layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel value="3_4" control={<Radio />} label={ETVConstants.trans("3_4")} />
                <FormControlLabel value="9_16" control={<Radio />} label={ETVConstants.trans("9_16")} />
                <FormControlLabel value="freestyle" control={<Radio />} label={ETVConstants.trans("freestyle")} />
                <FormControlLabel value="raster" control={<Radio />} label={ETVConstants.trans("raster")} />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      );
    }

    printNofScrollingLines() {
      return (
        <FormControl component="fieldset">
          <FormLabel component="legend">{ETVConstants.trans("nof_lines")}</FormLabel>

          <Select
            aria-label="nof_lines"
            name="nof_lines"
            value={this.state.nof_lines}
            onChange={(e) => {this.setState({nof_lines:e.target.value})}}>

            <MenuItem value={1}>1 line</MenuItem>
            <MenuItem value={2}>2 lines</MenuItem>
            <MenuItem value={3}>3 lines</MenuItem>
            <MenuItem value={4}>4 lines</MenuItem>
            <MenuItem value={5}>5 lines</MenuItem>
            <MenuItem value={6}>6 lines</MenuItem>
            <MenuItem value={7}>7 lines</MenuItem>
            <MenuItem value={8}>8 lines</MenuItem>
            <MenuItem value={9}>9 lines</MenuItem>
            <MenuItem value={10}>10 lines</MenuItem>
          </Select>
        </FormControl>
      );
    }

    printElevatorTouchButtonType() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("elevator_touch_button_help")}
          </Typography>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            {this.printTouchButtonTypes()}
          </Paper>

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("channel_layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel value="1_1" control={<Radio />} label={ETVConstants.trans("1_1")} />
                <FormControlLabel value="3_4" control={<Radio />} label={ETVConstants.trans("3_4")} />
                <FormControlLabel value="9_16" control={<Radio />} label={ETVConstants.trans("9_16")} />
                <FormControlLabel value="freestyle" control={<Radio />} label={ETVConstants.trans("freestyle")} />
                <FormControlLabel value="raster" control={<Radio />} label={ETVConstants.trans("raster")} />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      );
    }

    printTouchButtonTypes() {
      return    <FormControl component="fieldset">
                  <FormLabel component="legend">{ETVConstants.trans("touch_button_type")}</FormLabel>
                  <Select aria-label="format" name="format1" value={this.state.touch_button_type} onChange={(e) => {this.setState({touch_button_type:e.target.value})}}>
                    <MenuItem value={1}>Buttons</MenuItem>
                    <MenuItem value={2}>Scrolling</MenuItem>
                    <MenuItem value={3}>2 Step</MenuItem>
                  </Select>
                </FormControl>
    }

    printNofLines() {
      return    <FormControl component="fieldset">
                  <FormLabel component="legend">{ETVConstants.trans("nof_lines")}</FormLabel>
                  <Select aria-label="format" name="format1" value={this.state.nof_lines} onChange={(e) => {this.setState({nof_lines:e.target.value})}}>
                    <MenuItem value={1}>1 line</MenuItem>
                    <MenuItem value={2}>2 lines</MenuItem>
                    <MenuItem value={3}>3 lines</MenuItem>
                    <MenuItem value={4}>4 lines</MenuItem>
                  </Select>
                </FormControl>
    }

    printFloorDirectoryNoScrollingType() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("floor_directory_help")}
          </Typography>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            {this.printNofLines()}
          </Paper>

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("channel_layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel value="3_4" control={<Radio />} label={ETVConstants.trans("3_4")} />
                <FormControlLabel value="9_16" control={<Radio />} label={ETVConstants.trans("9_16")} />
                <FormControlLabel value="freestyle" control={<Radio />} label={ETVConstants.trans("freestyle")} />
                <FormControlLabel value="raster" control={<Radio />} label={ETVConstants.trans("raster")} />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      );
    }

    printRemoteElevatorViewType() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("remote_elevator_view")}
          </Typography>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            <FormLabel>{ETVConstants.trans("remote_elevator_view")}</FormLabel>

            <TextField
              id="remote_elevator_txt"
              label={ETVConstants.trans("remote_elevator_txt")}
              fullWidth
              margin="normal"
              size="small"
              value={this.state.remote_elevator_txt}
              onChange={(e)=>this.setState({remote_elevator_txt:e.target.value})}
            />

            <TextField
              id="remote_elevator_id"
              label={ETVConstants.trans("remote_elevator_id")}
              fullWidth
              margin="normal"
              size="small"
              value={this.state.remote_elevator_id}
              onChange={(e)=>this.setState({remote_elevator_id:e.target.value})}
            />

            <TextField
              id="remote_elevator_ip"
              label={ETVConstants.trans("remote_elevator_ip")}
              fullWidth
              margin="normal"
              size="small"
              value={this.state.remote_elevator_ip}
              onChange={(e)=>this.setState({remote_elevator_ip:e.target.value})}
            />
          </Paper>

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("channel_layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel value="3_4" control={<Radio />} label={ETVConstants.trans("3_4")} />
                <FormControlLabel value="4_3" control={<Radio />} label={ETVConstants.trans("4_3")} />
                <FormControlLabel value="9_16" control={<Radio />} label={ETVConstants.trans("9_16")} />
                <FormControlLabel value="1_1" control={<Radio />} label={ETVConstants.trans("square")} />
                <FormControlLabel value="freestyle" control={<Radio />} label={ETVConstants.trans("freestyle")} />
                <FormControlLabel value="raster" control={<Radio />} label={ETVConstants.trans("raster")} />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      );
    }

    print_KONE_DCS_QUEUE_VIEW_Type() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("channel_layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel value="16_9" control={<Radio />} label={ETVConstants.trans("16_9")} />
                <FormControlLabel value="freestyle" control={<Radio />} label={ETVConstants.trans("freestyle")} />
                <FormControlLabel value="raster" control={<Radio />} label={ETVConstants.trans("raster")} />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      );
    }

    printQRType() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("widget_qr_code_help")}
          </Typography>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            <FormLabel>{ETVConstants.trans("qr_code")}</FormLabel>

            <TextField
              id="qr_code_url"
              label={ETVConstants.trans("qr_code")}
              fullWidth
              margin="normal"
              size="small"
              value={this.state.qr_code}
              onChange={(e)=>{this.setState({qr_code:e.target.value})}}
            />
          </Paper>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("channel_layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel
                  value="1_1"
                  control={<Radio />}
                  label={ETVConstants.trans("1_1")}
                />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      );
    }

    printStreamingType() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("widget_streaming_help")}
          </Typography>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            <FormLabel>{ETVConstants.trans("streaming_settings")}</FormLabel>

            <TextField
              id="streaming_ip"
              label={ETVConstants.trans("streaming_ip")}
              fullWidth
              margin="normal"
              size="small"
              value={this.state.streaming_ip}
              onChange={(e)=>this.setState({streaming_ip:e.target.value})}
            />

            <TextField
              id="streaming_backup"
              label={ETVConstants.trans("streaming_backup")}
              fullWidth
              margin="normal"
              size="small"
              value={this.state.streaming_backup}
              onChange={(e)=>{this.setState({streaming_backup:e.target.value})}}
            />

            <TextField
              id="streaming_ip_supervision"
              label={ETVConstants.trans("streaming_ip_supervision")}
              fullWidth
              margin="normal"
              size="small"
              value={this.state.streaming_ip_supervision}
              onChange={(e)=>{this.setState({streaming_ip_supervision:e.target.value})}}
            />
          </Paper>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("channel_layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel
                  value="4_3"
                  control={<Radio />}
                  label={ETVConstants.trans("4_3")}
                />

                <FormControlLabel
                  value="16_9"
                  control={<Radio />}
                  label={ETVConstants.trans("16_9")}
                />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      );
    }

    printTripCounterType() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("widget_trip_counter_help")}
          </Typography>

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("channel_layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel
                  value="1_1"
                  control={<Radio />}
                  label={ETVConstants.trans("square")}
                />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      );
    }

    printContentRoundedCornerChoice() {
      return (
        <FormControl component="fieldset">
          <FormLabel component="legend">content rounded corners</FormLabel>
          <RadioGroup
            aria-label="content_rounded_corner"
            name="content_rounded_corner"
            value={String(this.state.content_rounded_corner)}
            onChange={(e) => {
              this.setState({ content_rounded_corner: parseInt(e.target.value, 10) });
            }}
          >
            <FormControlLabel value="0" control={<Radio />} label="no" />
            <FormControlLabel value="1" control={<Radio />} label="yes" />
          </RadioGroup>
        </FormControl>
      );
    }    

    printWidgetBGChoices() {
      return (
        <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
          <FormControl component="fieldset">
            <FormLabel component="legend">{ETVConstants.trans("background")}</FormLabel>

            <RadioGroup
              aria-label="background"
              name="widget_background"
              value={this.state.widget_background}
              onChange={(e) => {this.setState({widget_background:e.target.value})}}>

              <FormControlLabel
                value="full_transparent"
                control={<Radio />}
                label={ETVConstants.trans("full_transparent")}
              />

              <FormControlLabel
                value="half_transparent"
                control={<Radio />}
                label={ETVConstants.trans("half_transparent")}
              />

              <FormControlLabel
                value="white"
                control={<Radio />}
                label={ETVConstants.trans("white")}
              />

              <FormControlLabel
                value="black"
                control={<Radio />}
                label={ETVConstants.trans("black")}
              />

              <FormControlLabel
                value="black_gradient_top_down"
                control={<Radio />}
                label={ETVConstants.trans("black_gradient_top_down")}
              />

              <FormControlLabel
                value="black_gradient_bottom_up"
                control={<Radio />}
                label={ETVConstants.trans("black_gradient_bottom_up")}
              />

              <FormControlLabel
                value="border"
                control={<Radio />}
                label={ETVConstants.trans("border")}
              />
            </RadioGroup>
          </FormControl>
        </Paper>
      );
    }

    printTimeChoices() {
      return(
        <FormControl component="fieldset">
          <FormLabel component="legend">{ETVConstants.trans("time_format")}</FormLabel>

          <Select
            aria-label="format"
            name="clock_format"
            value={this.state.clock_format}
            onChange={(e) => {this.setState({clock_format:e.target.value})}}>

            <MenuItem value="HH:mm">13:55</MenuItem>
            <MenuItem value="H:mm">13:55</MenuItem>
            <MenuItem value="hh:mm">01:55</MenuItem>
            <MenuItem value="h:mm">1:55</MenuItem>

            <MenuItem value="HH:mm:ss">13:55:59</MenuItem>
            <MenuItem value="H:mm:ss">13:55:59</MenuItem>
            <MenuItem value="hh:mm:ss">01:55:59</MenuItem>
            <MenuItem value="h:mm:ss">1:55:59</MenuItem>

            <MenuItem value="hh:mm a">01:55 PM</MenuItem>
            <MenuItem value="h:mm a">1:55 PM</MenuItem>
            <MenuItem value="hh:mm:ss a">01:55:59 PM</MenuItem>
            <MenuItem value="h:mm:ss a">1:55:59 PM</MenuItem>

            <MenuItem value="dd-MM-yyyy">23-12-2022</MenuItem>
            <MenuItem value="dd/MM/yyyy">23/12/2022</MenuItem>
            <MenuItem value="dd.MM.yyyy">23.12.2022</MenuItem>

            <MenuItem value="MM-dd-yyyy">12-23-2022</MenuItem>
            <MenuItem value="MM/dd/yyyy">12/23/2022</MenuItem>
            <MenuItem value="MM.dd.yyyy">12.23.2022</MenuItem>

            <MenuItem value="yyyy-MM-dd">2022-12-23</MenuItem>
            <MenuItem value="yyyy/MM/dd">2022/12/23</MenuItem>
            <MenuItem value="yyyy.MM.dd">2022.12.23</MenuItem>

            <MenuItem value="dd MMM yyyy">23 Dec 2022</MenuItem>
            <MenuItem value="dd MMMM yyyy">23 December 2022</MenuItem>
            <MenuItem value="MMM dd, yyyy">Dec 23, 2022</MenuItem>
            <MenuItem value="MMMM dd, yyyy">December 23, 2022</MenuItem>

            <MenuItem value="1">localized Date Long (e.g. December 23, 2022)</MenuItem>
            <MenuItem value="2">localized Date Medium (e.g. Dec 23, 2022)</MenuItem>
            <MenuItem value="3">localized Date Short (e.g. 12/23/2022)</MenuItem>

            <MenuItem value="EEEE dd-MM-yyyy HH:mm">Monday, 23-12-2022 12:33</MenuItem>
            <MenuItem value="EEE dd-MMMM-yyyy HH:mm">Mon, 23-December-2022 12:33</MenuItem>
            <MenuItem value="EEE dd-MMMM-yyyy HH:mma">Mon, 23-December-2022 12:33PM</MenuItem>
            <MenuItem value="EEEE dd-MMMM-yyyy HH:mm">Monday, 23-December-2022 12:33</MenuItem>
            <MenuItem value="EEEE dd-MMMM-yyyy HH:mma">Monday, 23-December-2022 12:33PM</MenuItem>

            <MenuItem value="EEE, MMM dd, HH:mm">Mon, Dec 23, 12:33</MenuItem>
            <MenuItem value="EEE, MMM dd, HH:mma">Mon, Dec 23, 12:33PM</MenuItem>
            <MenuItem value="EEE, dd MMM">Mon, 23 Dec</MenuItem>
            <MenuItem value="EEEE, dd MMMM">Monday, 23 December</MenuItem>

            <MenuItem value="EEE, HH:mm">Mon, 13:55</MenuItem>
            <MenuItem value="EEEE, HH:mm">Monday, 13:55</MenuItem>
            <MenuItem value="EEE, h:mm a">Mon, 1:55 PM</MenuItem>
            <MenuItem value="EEEE, h:mm a">Monday, 1:55 PM</MenuItem>

            <MenuItem value="dd MMM HH:mm">23 Dec 13:55</MenuItem>
            <MenuItem value="MMM dd h:mm a">Dec 23 1:55 PM</MenuItem>

            <MenuItem value="EEE">Mon</MenuItem>
            <MenuItem value="EEEE">Monday</MenuItem>
          </Select>
        </FormControl>
      );
    }

    printDateChoices() {
       return(
        <FormControl component="fieldset">
          <FormLabel component="legend">{ETVConstants.trans("date_format")}</FormLabel>

          <Select
            aria-label="format"
            name="clock_format"
            value={this.state.clock_date_format}
            onChange={(e) => {this.setState({clock_date_format:e.target.value})}}>

            <MenuItem value="HH:mm">13:55</MenuItem>
            <MenuItem value="H:mm">13:55</MenuItem>
            <MenuItem value="hh:mm">01:55</MenuItem>
            <MenuItem value="h:mm">1:55</MenuItem>

            <MenuItem value="HH:mm:ss">13:55:59</MenuItem>
            <MenuItem value="H:mm:ss">13:55:59</MenuItem>
            <MenuItem value="hh:mm:ss">01:55:59</MenuItem>
            <MenuItem value="h:mm:ss">1:55:59</MenuItem>

            <MenuItem value="hh:mm a">01:55 PM</MenuItem>
            <MenuItem value="h:mm a">1:55 PM</MenuItem>
            <MenuItem value="hh:mm:ss a">01:55:59 PM</MenuItem>
            <MenuItem value="h:mm:ss a">1:55:59 PM</MenuItem>

            <MenuItem value="dd-MM-yyyy">23-12-2022</MenuItem>
            <MenuItem value="dd/MM/yyyy">23/12/2022</MenuItem>
            <MenuItem value="dd.MM.yyyy">23.12.2022</MenuItem>

            <MenuItem value="MM-dd-yyyy">12-23-2022</MenuItem>
            <MenuItem value="MM/dd/yyyy">12/23/2022</MenuItem>
            <MenuItem value="MM.dd.yyyy">12.23.2022</MenuItem>

            <MenuItem value="yyyy-MM-dd">2022-12-23</MenuItem>
            <MenuItem value="yyyy/MM/dd">2022/12/23</MenuItem>
            <MenuItem value="yyyy.MM.dd">2022.12.23</MenuItem>

            <MenuItem value="dd MMM yyyy">23 Dec 2022</MenuItem>
            <MenuItem value="dd MMMM yyyy">23 December 2022</MenuItem>
            <MenuItem value="MMM dd, yyyy">Dec 23, 2022</MenuItem>
            <MenuItem value="MMMM dd, yyyy">December 23, 2022</MenuItem>

            <MenuItem value="1">localized Date Long (e.g. December 23, 2022)</MenuItem>
            <MenuItem value="2">localized Date Medium (e.g. Dec 23, 2022)</MenuItem>
            <MenuItem value="3">localized Date Short (e.g. 12/23/2022)</MenuItem>

            <MenuItem value="EEEE dd-MM-yyyy HH:mm">Monday, 23-12-2022 12:33</MenuItem>
            <MenuItem value="EEE dd-MMMM-yyyy HH:mm">Mon, 23-December-2022 12:33</MenuItem>
            <MenuItem value="EEE dd-MMMM-yyyy HH:mma">Mon, 23-December-2022 12:33PM</MenuItem>
            <MenuItem value="EEEE dd-MMMM-yyyy HH:mm">Monday, 23-December-2022 12:33</MenuItem>
            <MenuItem value="EEEE dd-MMMM-yyyy HH:mma">Monday, 23-December-2022 12:33PM</MenuItem>

            <MenuItem value="EEE, MMM dd, HH:mm">Mon, Dec 23, 12:33</MenuItem>
            <MenuItem value="EEE, MMM dd, HH:mma">Mon, Dec 23, 12:33PM</MenuItem>
            <MenuItem value="EEE, dd MMM">Mon, 23 Dec</MenuItem>
            <MenuItem value="EEEE, dd MMMM">Monday, 23 December</MenuItem>

            <MenuItem value="EEE, HH:mm">Mon, 13:55</MenuItem>
            <MenuItem value="EEEE, HH:mm">Monday, 13:55</MenuItem>
            <MenuItem value="EEE, h:mm a">Mon, 1:55 PM</MenuItem>
            <MenuItem value="EEEE, h:mm a">Monday, 1:55 PM</MenuItem>

            <MenuItem value="dd MMM HH:mm">23 Dec 13:55</MenuItem>
            <MenuItem value="MMM dd h:mm a">Dec 23 1:55 PM</MenuItem>

            <MenuItem value="EEE">Mon</MenuItem>
            <MenuItem value="EEEE">Monday</MenuItem>
          </Select>
        </FormControl>
      );
    }

    printLangChoices() {
      return(
        <FormControl component="fieldset">
            <FormLabel component="legend">{ETVConstants.trans("clock_language")}</FormLabel>
            <Select aria-label="format" name="format1" value={this.state.clock_locale} onChange={(e) => {this.setState({clock_locale:e.target.value})}}>
              <MenuItem value="en">{ETVConstants.trans("english")}</MenuItem>
              <MenuItem value="de">{ETVConstants.trans("german")}</MenuItem>
              <MenuItem value="fr">{ETVConstants.trans("french")}</MenuItem>
              <MenuItem value="ja">{ETVConstants.trans("japanese")}</MenuItem>
              <MenuItem value="es">{ETVConstants.trans("spanish")}</MenuItem>
              <MenuItem value='zh'>{ETVConstants.trans("chinese")}</MenuItem>
              <MenuItem value='pt'>{ETVConstants.trans("portugese")}</MenuItem>
              <MenuItem value='it'>{ETVConstants.trans("italian")}</MenuItem>
              <MenuItem value='ko'>{ETVConstants.trans("korean")}</MenuItem>
              <MenuItem value='th'>{ETVConstants.trans("thai")}</MenuItem>
              <MenuItem value='vi'>{ETVConstants.trans("vietnamese")}</MenuItem>
           </Select>
        </FormControl>
      )
    }

    printTime3Type() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("widget_time_help")}
          </Typography>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            {this.printTimeChoices()}
          </Paper>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            {this.printDateChoices()}
          </Paper>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            {this.printLangChoices()}
          </Paper>

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("layout")}</FormLabel>
              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>
                <FormControlLabel
                  value="4_3"
                  control={<Radio />}
                  label={ETVConstants.trans("4_3")}
                />
                <FormControlLabel
                  value="16_9"
                  control={<Radio />}
                  label={ETVConstants.trans("16_9")}
                />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      );
    }

    printTime2Type() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("widget_time_help")}
          </Typography>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            {this.printTimeChoices()}
          </Paper>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            {this.printDateChoices()}
          </Paper>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            {this.printLangChoices()}
          </Paper>

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel
                  value="4_3"
                  control={<Radio />}
                  label={ETVConstants.trans("4_3")}
                />

                <FormControlLabel
                  value="16_9"
                  control={<Radio />}
                  label={ETVConstants.trans("16_9")}
                />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      );
    }

    printTimeSimpleType() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("widget_time_simple_help")}
          </Typography>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            {this.printTimeChoices()}
          </Paper>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            {this.printLangChoices()}
          </Paper>

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel
                  value="freestyle"
                  control={<Radio />}
                  label={ETVConstants.trans("freestyle")}
                />

                <FormControlLabel
                  value="raster"
                  control={<Radio />}
                  label={ETVConstants.trans("raster")}
                />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      )
    }

    printWeatherType() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("widget_weather_help")}
          </Typography>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            <FormLabel>{ETVConstants.trans("location")}</FormLabel>

            <div style={{marginTop:16, marginBottom:16}}>
              <Button
                id="choose_btn"
                variant="contained"
                color="primary"
                onClick={()=>this.showWindow("location_map_div", true)}>
                {ETVConstants.trans("choose_location")}
              </Button>
            </div>

            <div style={{display:'flex', gap:12, marginBottom:8}}>
              <TextField
                id="weather_city_lat"
                disabled={true}
                label={ETVConstants.trans("latitude")}
                size="small"
                fullWidth
                value={this.state.weather_city_lat}
                onChange={(e)=>{this.setState({weather_city_lat:e.target.value})}}
              />

              <TextField
                id="weather_city_lgt"
                disabled={true}
                label={ETVConstants.trans("longitude")}
                size="small"
                fullWidth
                value={this.state.weather_city_lgt}
                onChange={(e)=>{this.setState({weather_city_lgt:e.target.value})}}
              />
            </div>

            <TextField
              id="weather_city_name"
              label={ETVConstants.trans("weather_city_name")}
              size="small"
              fullWidth
              margin="normal"
              value={this.state.weather_city_name}
              onChange={(e)=>{this.setState({weather_city_name:e.target.value})}}
            />
          </Paper>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("weather_units")}</FormLabel>

              <RadioGroup
                aria-label="weather_units"
                name="weather_units"
                value={this.state.weather_units || "celsius"}
                onChange={(e) => {this.setState({weather_units:e.target.value})}}>

                <FormControlLabel
                  value="celsius"
                  control={<Radio />}
                  label={ETVConstants.trans("celsius")}
                />

                <FormControlLabel
                  value="fahrenheit"
                  control={<Radio />}
                  label={ETVConstants.trans("fahrenheit")}
                />
              </RadioGroup>
            </FormControl>
          </Paper>          

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel
                  value="1_1"
                  control={<Radio />}
                  label={ETVConstants.trans("square")}
                />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      )
    }

    printWeather5Type() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("widget_weather_help")}
          </Typography>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            <FormLabel>{ETVConstants.trans("location")}</FormLabel>

            <div style={{marginTop:16, marginBottom:16}}>
              <Button
                id="choose_btn"
                variant="contained"
                color="primary"
                onClick={()=>this.showWindow("location_map_div", true)}>
                {ETVConstants.trans("choose_location")}
              </Button>
            </div>

            <div style={{display:'flex', gap:12, marginBottom:8}}>
              <TextField
                id="weather_city_lat"
                disabled={true}
                label={ETVConstants.trans("latitude")}
                size="small"
                fullWidth
                value={this.state.weather_city_lat}
                onChange={(e)=>{this.setState({weather_city_lat:e.target.value})}}
              />

              <TextField
                id="weather_city_lgt"
                disabled={true}
                label={ETVConstants.trans("longitude")}
                size="small"
                fullWidth
                value={this.state.weather_city_lgt}
                onChange={(e)=>{this.setState({weather_city_lgt:e.target.value})}}
              />
            </div>

            <TextField
              id="weather_city_name"
              label={ETVConstants.trans("weather_city_name")}
              size="small"
              fullWidth
              margin="normal"
              value={this.state.weather_city_name}
              onChange={(e)=>{this.setState({weather_city_name:e.target.value})}}
            />
          </Paper>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("weather_units")}</FormLabel>

              <RadioGroup
                aria-label="weather_units"
                name="weather_units"
                value={this.state.weather_units || "celsius"}
                onChange={(e) => {this.setState({weather_units:e.target.value})}}>

                <FormControlLabel
                  value="celsius"
                  control={<Radio />}
                  label={ETVConstants.trans("celsius")}
                />

                <FormControlLabel
                  value="fahrenheit"
                  control={<Radio />}
                  label={ETVConstants.trans("fahrenheit")}
                />
              </RadioGroup>
            </FormControl>
          </Paper>          

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel
                  value="16_9"
                  control={<Radio />}
                  label={ETVConstants.trans("16_9")}
                />

                <FormControlLabel
                  value="4_3"
                  control={<Radio />}
                  label={ETVConstants.trans("4_3")}
                />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      )
    }

    printSpeedType() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("widget_speed_help")}
          </Typography>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            <FormLabel>{ETVConstants.trans("speed_display")}</FormLabel>

            <TextField
              id="speed_title"
              label={ETVConstants.trans("speed_title")}
              size="small"
              fullWidth
              margin="normal"
              value={this.state.speed_title}
              onChange={(e)=>{this.setState({speed_title:e.target.value})}}
            />

            <FormControl component="fieldset" style={{marginTop:16}}>
              <FormLabel component="legend">{ETVConstants.trans("custom_title_color")}</FormLabel>

              <RadioGroup
                aria-label="custom_title_color"
                name="custom_title_color"
                value={this.state.custom_title_color === "" ? "default" : "custom"}
                onChange={(e) => {
                  this.setState({
                    custom_title_color: e.target.value === "default" ? "" : "#0099ff"
                  })
                }}>

                <FormControlLabel
                  value="default"
                  control={<Radio />}
                  label={ETVConstants.trans("default_color")}
                />

                <FormControlLabel
                  value="custom"
                  control={<Radio />}
                  label={ETVConstants.trans("custom_title_color")}
                />
              </RadioGroup>
            </FormControl>

            {this.state.custom_title_color !== "" &&
              <div style={{display:'flex', alignItems:'center', gap:12, marginTop:12}}>
                <TextField
                  id="custom_title_color"
                  label={ETVConstants.trans("custom_title_color")}
                  size="small"
                  type="color"
                  value={this.state.custom_title_color}
                  onChange={(e)=>{this.setState({custom_title_color:e.target.value})}}
                  style={{width:120}}
                />

                <Typography variant="body2" style={{color:'gray'}}>
                  {this.state.custom_title_color}
                </Typography>
              </div>
            }
          </Paper>

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel
                  value="1.5_1"
                  control={<Radio />}
                  label={ETVConstants.trans("1.5_1")}
                />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      )
    }

    printSpeedType2() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("widget_speed_help")}
          </Typography>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            <FormLabel>{ETVConstants.trans("speed_display")}</FormLabel>

            <TextField
              id="speed_title"
              label={ETVConstants.trans("speed_title")}
              size="small"
              fullWidth
              margin="normal"
              value={this.state.speed_title}
              onChange={(e)=>{this.setState({speed_title:e.target.value})}}
            />

            <TextField
              id="max_speed"
              label={ETVConstants.trans("max_speed")}
              size="small"
              type="number"
              fullWidth
              margin="normal"
              value={this.state.max_speed}
              inputProps={{
                inputMode: 'decimal',
                step: '0.1',
                min: '0.1'
              }}
              onChange={(e) => {
                const value = e.target.value
                if (/^\d*\.?\d{0,1}$/.test(value)) {
                  this.setState({max_speed:value})
                }
              }}
            />

            <FormControl component="fieldset" style={{marginTop:16}}>
              <FormLabel component="legend">{ETVConstants.trans("needle_color")}</FormLabel>

              <RadioGroup
                aria-label="needle_color"
                name="needle_color"
                value={this.state.needle_color === "" ? "default" : "custom"}
                onChange={(e) => {
                  this.setState({
                    needle_color: e.target.value === "default" ? "" : "#0099ff"
                  })
                }}>

                <FormControlLabel
                  value="default"
                  control={<Radio />}
                  label={ETVConstants.trans("default_color")}
                />

                <FormControlLabel
                  value="custom"
                  control={<Radio />}
                  label={ETVConstants.trans("selected_needle_color")}
                />
              </RadioGroup>
            </FormControl>

            {this.state.needle_color !== "" &&
              <div style={{display:'flex', alignItems:'center', gap:12, marginTop:12}}>
                <TextField
                  id="needle_color"
                  label={ETVConstants.trans("needle_color")}
                  size="small"
                  type="color"
                  value={this.state.needle_color}
                  onChange={(e)=>{this.setState({needle_color:e.target.value})}}
                  style={{width:120}}
                />

                <Typography variant="body2" style={{color:'gray'}}>
                  {this.state.needle_color}
                </Typography>
              </div>
            }
          </Paper>

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel
                  value="1_1"
                  control={<Radio />}
                  label={ETVConstants.trans("1_1")}
                />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      )
    }    

    printHeightType2() {
      const heightIconColor = this.state.height_icon_color || "";
      const useCustomHeightIconColor = heightIconColor !== "";

      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("widget_height_help")}
          </Typography>

          <Paper
            elevation={0}
            style={{
              padding:12,
              marginBottom:16,
              border:'1px solid #e0e0e0'
            }}>

            <Typography variant="body2" style={{marginBottom:4, color:'rgba(0,0,0,0.65)'}}>
              {ETVConstants.trans("height_icon_color")}
            </Typography>

            <RadioGroup
              aria-label="height_icon_color"
              name="height_icon_color"
              value={useCustomHeightIconColor ? "custom" : "default"}
              onChange={(e) => {
                this.setState({
                  height_icon_color:
                    e.target.value === "default"
                      ? ""
                      : "#0099ff"
                });
              }}>

              <FormControlLabel
                value="default"
                control={<Radio />}
                label={ETVConstants.trans("default_color")}
              />

              <FormControlLabel
                value="custom"
                control={<Radio />}
                label="custom color"
              />
            </RadioGroup>

            {useCustomHeightIconColor && (
              <div
                style={{
                  display:'flex',
                  alignItems:'center',
                  gap:12,
                  marginTop:8
                }}>

                <TextField
                  id="height_icon_color"
                  label={ETVConstants.trans("height_icon_color")}
                  size="small"
                  type="color"
                  value={heightIconColor}
                  onChange={(e) => {
                    this.setState({height_icon_color:e.target.value});
                  }}
                  style={{width:120}}
                />

                <Typography variant="body2" style={{color:'gray'}}>
                  {heightIconColor}
                </Typography>
              </div>
            )}
          </Paper>

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <Paper
            elevation={0}
            style={{
              padding:12,
              border:'1px solid #e0e0e0'
            }}>

            <Typography variant="subtitle2" style={{marginBottom:8}}>
              {ETVConstants.trans("layout")}
            </Typography>

            <RadioGroup
              aria-label="layout"
              name="channelLayout"
              value={this.state.channelLayout || "1_6"}
              onChange={(e) => {
                this.setState({channelLayout:e.target.value});
              }}>

              <FormControlLabel
                value="1_6"
                control={<Radio />}
                label={ETVConstants.trans("1_6")}
              />
            </RadioGroup>
          </Paper>
        </Paper>
      );
    }

    printHeightType() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("widget_height_help")}
          </Typography>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            <FormLabel>{ETVConstants.trans("height_display")}</FormLabel>

            <TextField
              id="height_title"
              label={ETVConstants.trans("height_title")}
              size="small"
              fullWidth
              margin="normal"
              value={this.state.height_title}
              onChange={(e)=>{this.setState({height_title:e.target.value})}}
            />

            <FormControl component="fieldset" style={{marginTop:16}}>
                <FormLabel component="legend">{ETVConstants.trans("custom_title_color")}</FormLabel>

                <RadioGroup
                  aria-label="custom_title_color"
                  name="custom_title_color"
                  value={this.state.custom_title_color === "" ? "default" : "custom"}
                  onChange={(e) => {
                    this.setState({
                      custom_title_color: e.target.value === "default" ? "" : "#0099ff"
                    })
                  }}>

                  <FormControlLabel
                    value="default"
                    control={<Radio />}
                    label={ETVConstants.trans("default_color")}
                  />

                  <FormControlLabel
                    value="custom"
                    control={<Radio />}
                    label={ETVConstants.trans("custom_title_color")}
                  />
                </RadioGroup>
              </FormControl>

              {this.state.custom_title_color !== "" &&
                <div style={{display:'flex', alignItems:'center', gap:12, marginTop:12}}>
                  <TextField
                    id="custom_title_color"
                    label={ETVConstants.trans("custom_title_color")}
                    size="small"
                    type="color"
                    value={this.state.custom_title_color}
                    onChange={(e)=>{this.setState({custom_title_color:e.target.value})}}
                    style={{width:120}}
                  />

                  <Typography variant="body2" style={{color:'gray'}}>
                    {this.state.custom_title_color}
                  </Typography>
                </div>
              }
            </Paper>

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel
                  value="1.5_1"
                  control={<Radio />}
                  label={ETVConstants.trans("1.5_1")}
                />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      )
    }

    printElevatorLandscapeType() {
      return(
        <div style={{border:"1px solid lightgrey", backgroundColor:'#FDFDFD', marginRight:20, padding:10}}>
           <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("channel_layout")}</FormLabel>
              <RadioGroup aria-label="format" name="format1" value={this.state.channelLayout} onChange={(e) => {this.setState({channelLayout:e.target.value})}}>
                <FormControlLabel value="4_3" control={<Radio />} label={ETVConstants.trans("4_3")} />
                <FormControlLabel value="16_9" control={<Radio />} label={ETVConstants.trans("16_9")} />
                <FormControlLabel value="1_1" control={<Radio />} label={ETVConstants.trans("square")} />
                <FormControlLabel value="freestyle" control={<Radio />} label={ETVConstants.trans("freestyle")} />
                <FormControlLabel value="raster" control={<Radio />} label={ETVConstants.trans("raster")} />
              </RadioGroup>
           </FormControl>
        </div>
      )
    }

    printElevatorPortraitType() {
      return(
        <div style={{border:"1px solid lightgrey", backgroundColor:'#FDFDFD', marginRight:20, padding:10}}>
           <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("channel_layout")}</FormLabel>
              <RadioGroup aria-label="format" name="format1" value={this.state.channelLayout} onChange={(e) => {this.setState({channelLayout:e.target.value})}}>
                <FormControlLabel value="3_4" control={<Radio />} label={ETVConstants.trans("4_3")} />
                <FormControlLabel value="9_16" control={<Radio />} label={ETVConstants.trans("9_16")} />
                <FormControlLabel value="freestyle" control={<Radio />} label={ETVConstants.trans("freestyle")} />
                <FormControlLabel value="raster" control={<Radio />} label={ETVConstants.trans("raster")} />
              </RadioGroup>
           </FormControl>
        </div>
      )
    }

    printElevatorFloorPicsType() {
      return(
        <div style={{border:"1px solid lightgrey", backgroundColor:'#FDFDFD', marginRight:20, padding:10}}>
         <FormControl component="fieldset">
            <FormLabel component="legend">{ETVConstants.trans("channel_layout")}</FormLabel>
            <RadioGroup aria-label="format" name="format1" value={this.state.channelLayout} onChange={(e) => {this.setState({channelLayout:e.target.value})}}>
              <FormControlLabel value="4_3" control={<Radio />} label={ETVConstants.trans("4_3")}/>
              <FormControlLabel value="3_4" control={<Radio />} label={ETVConstants.trans("3_4")} />
              <FormControlLabel value="16_9" control={<Radio />} label={ETVConstants.trans("16_9")} />
              <FormControlLabel value="9_16" control={<Radio />} label={ETVConstants.trans("9_16")} />
              <FormControlLabel value="freestyle" control={<Radio />} label={ETVConstants.trans("freestyle")} />
              <FormControlLabel value="raster" control={<Radio />} label={ETVConstants.trans("raster")} />
            </RadioGroup>
         </FormControl>
        </div>
      )
    }

    printStaticTextType() {
      return (
        <Paper elevation={2} style={{marginRight:20, padding:16, backgroundColor:'#FDFDFD'}}>
          <Typography
            style={{color:'gray', marginBottom:16}}
            component="div"
            gutterBottom
            variant="body2">
            {ETVConstants.trans("widget_static_text_help")}
          </Typography>

          <Paper elevation={0} style={{padding:12, marginBottom:16, border:'1px solid #e0e0e0'}}>
            <FormLabel>{ETVConstants.trans("text")}</FormLabel>

            <TextField
              id="static_txt_line_1"
              fullWidth
              margin="normal"
              label={ETVConstants.trans("text")}
              size="small"
              value={this.state.static_txt_line_1}
              onChange={(e)=>{this.setState({static_txt_line_1:e.target.value})}}
            />
          </Paper>

          <div style={{marginBottom:16}}>
            {this.printWidgetBGChoices()}
          </div>

          <div style={{marginBottom:16}}>
            {this.printWidgetTextColorChoices()}
          </div>

          <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{ETVConstants.trans("channel_layout")}</FormLabel>

              <RadioGroup
                aria-label="layout"
                name="channelLayout"
                value={this.state.channelLayout}
                onChange={(e) => {this.setState({channelLayout:e.target.value})}}>

                <FormControlLabel
                  value="4_3"
                  control={<Radio />}
                  label={ETVConstants.trans("4_3")}
                />

                <FormControlLabel
                  value="16_9"
                  control={<Radio />}
                  label={ETVConstants.trans("16_9")}
                />

                <FormControlLabel
                  value="raster"
                  control={<Radio />}
                  label={ETVConstants.trans("raster")}
                />

                <FormControlLabel
                  value="freestyle"
                  control={<Radio />}
                  label={ETVConstants.trans("freestyle")}
                />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Paper>
      );
    }

    printWidgetTextColorChoices() {
      return (
        <Paper elevation={0} style={{padding:12, border:'1px solid #e0e0e0'}}>
          <FormControl component="fieldset">
            <FormLabel component="legend">{ETVConstants.trans("widget_text_color")}</FormLabel>

            <RadioGroup
              aria-label="widget_text_color"
              name="widget_text_color"
              value={this.state.widget_text_color === "" ? "default" : "custom"}
              onChange={(e) => {
                this.setState({
                  widget_text_color: e.target.value === "default" ? "" : "#ffffff"
                })
              }}>

              <FormControlLabel
                value="default"
                control={<Radio />}
                label={ETVConstants.trans("default_color")}
              />

              <FormControlLabel
                value="custom"
                control={<Radio />}
                label={ETVConstants.trans("selected_text_color")}
              />
            </RadioGroup>
          </FormControl>

          {this.state.widget_text_color !== "" &&
            <div style={{display:'flex', alignItems:'center', gap:12, marginTop:12}}>
              <TextField
                id="widget_text_color"
                label={ETVConstants.trans("widget_text_color")}
                size="small"
                type="color"
                value={this.state.widget_text_color}
                onChange={(e)=>{this.setState({widget_text_color:e.target.value})}}
                style={{width:120}}
              />

              <Typography variant="body2" style={{color:'gray'}}>
                {this.state.widget_text_color}
              </Typography>
            </div>
          }
        </Paper>
      )
    }

    printWidgetTextHighlightChoices() {
      return(
        <FormControl component="fieldset">
            <FormLabel component="legend">{ETVConstants.trans("highlight_text_color")}</FormLabel>
              <input style={{marginTop:'10px'}} type="color" value={this.state.highlight_color} onChange={(e) => this.setState({highlight_color:e.target.value})}/>
              <Button style={{marginTop:'5px'}} size='small' variant='outlined' color='primary' onClick={(e)=>{this.setState({highlight_color:''})}}>set default</Button>
        </FormControl>
      )
    }

    readerBGImageLoaded = (e) => {
      const content = e.target.result;
      //console.log("readerLoaded="+content);
      const image = new Image();
      image.onload = () => this.bgImageLoaded(image, content);
      image.onerror = () => this.showErrorMessage(
        ETVConstants.trans("error"),
        ETVConstants.trans("invalid_image")
      );
      image.src = content;
    }

    loadBG(selectorFiles) {
      //console.log(selectorFiles[0]);
      var file = selectorFiles[0];
      var reader  = new FileReader();
      reader.onloadend = this.readerBGImageLoaded;
      if (file) {
        reader.readAsDataURL(file);
      }
    }

    bgImageLoaded(image, content) {
      // Keep cWidth, cHeight, canvasResolution, orientation, and existing channels.
      // drawImageCover() adapts the image to the already selected layout rectangle.
      this.setState({
        canvas_img: image,
        canvas_bg: content,
        bgImage: image,
        canvas_bg_color: '#FFFFFF',
        window: '',
        needRedraw: true,
      });
    }

    estimateResolution(ratio) {
      //console.log("estimate resolution=" + ratio);
      if (!Number.isFinite(ratio) || ratio <= 0) return -1.0;

      // keep your catalog; duplicates removed programmatically
      const candidates = [
        1.33, 0.75, 1.7778, 0.5625, 0.625, 1.6, 2.05556, 1.71,
        1.6, 1.506, 1.25, 0.8, 0.4865, 0.625, 0.5859375, 0.664, 1.0
      ];

      // de-duplicate (tolerant to tiny float differences)
      const uniq = [];
      for (const r of candidates) {
        if (!uniq.some(x => Math.abs(x - r) < 1e-6)) uniq.push(r);
      }

      // find the closest
      let best = uniq[0];
      let bestDiff = Math.abs(ratio - best);
      for (let i = 1; i < uniq.length; i++) {
        const d = Math.abs(ratio - uniq[i]);
        if (d < bestDiff) {
          best = uniq[i];
          bestDiff = d;
        }
      }

      // Optional cutoff: only accept if within ~2%
      // const TOL = 0.02;
      // return bestDiff <= TOL ? best : -1.0;
      //console.log("found best="+best);
      return best; // always return the closest ratio
    }


    createDeviceResolutionDropDown() {
      const { isLoaded, devices, selected_ratio } = this.state;

      if (!isLoaded) {
        return "loading...";
      }

      // build options once
      const options = devices.flatMap((device, index) => [
        {
          key: `${index}_l`,
          label: `${device.device_name} (Landscape)`,
          value: device.screen_ratio,
        },
        {
          key: `${index}_p`,
          label: `${device.device_name} (Portrait)`,
          value: Number((1.0 / device.screen_ratio).toFixed(4)),
        },
      ]);

      const selectedOption = options.find(o => o.value === selected_ratio) || null;

      return (
        <FormControl>
          <Autocomplete
            options={options}
            value={selectedOption}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            onChange={(event, newValue) => {
              if (newValue) {
                this.handleCanvasResolutionChange({
                  target: { value: newValue.value }
                });
              }
            }}
            sx={{ width: 300 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={ETVConstants.trans("screen")}
                variant="outlined"
              />
            )}
          />
        </FormControl>
      );
    }

    createScreenResolutionDropDown() {
      return(                            
        <FormControl style={{marginLeft:10}}>
          <InputLabel component="legend">{ETVConstants.trans("screen_resolution")}</InputLabel>
          <Select
            label={ETVConstants.trans("screen_resolution")}
            id="sizeID"
            style={{ width:200}}
            value={this.state.canvasResolution}
            onChange={this.handleCanvasResolutionChange}>
            <MenuItem value={1.33334}>4:3 landscape</MenuItem>
            <MenuItem value={0.75}>4:3 portrait</MenuItem>
            <MenuItem value={1.7778}>16:9 landscape </MenuItem>
            <MenuItem value={0.5625}>16:9 portrait </MenuItem>
            <MenuItem value={0.625}>16:10 portrait </MenuItem>
            <MenuItem value={1.6}>16:10 landscape </MenuItem>
            <MenuItem value={2.05556}>740 x 360 (ratio:2.06)</MenuItem>
            <MenuItem value={1.6}>960 x 600 (ratio:1.6)</MenuItem>
            <MenuItem value={1.33334}>1024 x 768  (4:3)</MenuItem>
            <MenuItem value={1.71}>1280 x 750</MenuItem>
            <MenuItem value={1.6}>1280 x 800 (16:10)</MenuItem>
            <MenuItem value={1.506}>1280 x 850 (ratio:1.506)</MenuItem>
            <MenuItem value={1.25}>1280 x 1024 (5:4) 19 inch</MenuItem>
            <MenuItem value={0.8}>1024 x 1280 (4:5) 19 inch</MenuItem>
            <MenuItem value={1.7778}>1920 x 1080</MenuItem>
            <MenuItem value={0.4865}>360 x 740 (ratio:2.06)</MenuItem>
            <MenuItem value={0.625}>600 x 960 (ratio:1.6)</MenuItem>
            <MenuItem value={0.5859375}>750 x 1280</MenuItem>
            <MenuItem value={0.75}>768 x 1024 (3:4)</MenuItem>
            <MenuItem value={0.625}>800 x 1280 (10:16)</MenuItem>
            <MenuItem value={0.664}>850 x 1280 (ratio:1.506)</MenuItem>
            <MenuItem value={0.8}>1024 x 1280 (ratio:0.8)</MenuItem>
            <MenuItem value={0.5625}>1080 x 1920</MenuItem>
            <MenuItem value={1.0}>Square (special screen)</MenuItem>
            <MenuItem value={-1}>{ETVConstants.trans("unknown")}</MenuItem>
          </Select>
        </FormControl>
      )
    }

    renderChannelTypeSettings() {
      const renderers = {
        streaming: () => this.printStreamingType(),
        arrow: () => this.printArrowType(),
        door: () => this.printDoorType(),
        qrcode: () => this.printQRType(),
        floornumber: () => this.printFloorNumberType(),
        next_stop: () => this.printNextStopType(),
        next_stop_2: () => this.printNextStop2Type(),
        next_stop_3: () => this.printNextStop3Type(),
        next_stop_list: () => this.printNextStopListType(),
        next_stop_list_2: () => this.printNextStopListType2(),
        floor_directory_noscrolling: () => this.printFloorDirectoryNoScrollingType(),
        remote_elevator_view: () => this.printRemoteElevatorViewType(),
        kone_dcs_queue_message_view: () => this.print_KONE_DCS_QUEUE_VIEW_Type(),
        floor_directory: () => this.printFloorDirectoryType(),
        elevator_touch_button_scrolling: () => this.printElevatorTouchButtonType(),
        elevator_touch_button_10: () => this.printElevatorTouchButtonType(),
        elevator_touch_button: () => this.printElevatorTouchButtonType(),
        time3V2: () => this.printTime3Type(),
        time3: () => this.printTime3Type(),
        time2: () => this.printTime2Type(),
        time1: () => this.printTimeSimpleType(),
        weather: () => this.printWeatherType(),
        weather5: () => this.printWeather5Type(),
        speed: () => this.printSpeedType(),
        speed2: () => this.printSpeedType2(),
        height: () => this.printHeightType(),
        height2: () => this.printHeightType2(),
        elevator_landscape: () => this.printElevatorLandscapeType(),
        elevator_portrait: () => this.printElevatorPortraitType(),
        floorpics: () => this.printElevatorFloorPicsType(),
        statictext: () => this.printStaticTextType(),
        tripcounter: () => this.printTripCounterType(),
      };
      const renderer = renderers[this.state.channel_type];
      if (renderer) {
        return renderer();
      }
      return this.renderDefaultChannelTypeSettings();
    }

    renderDefaultChannelTypeSettings() {
      const isContentType = this.state.channel_type === 'content';
      return (
        <div style={{border:"1px solid lightgrey", backgroundColor:'#FDFDFD', marginRight:20, padding:10}}>
          {isContentType ? ( <> {this.printContentRoundedCornerChoice()}<br/><br/></>) : null}
          <FormControl component="fieldset">
            <FormLabel component="legend">{ETVConstants.trans("channel_layout")}</FormLabel>
            <RadioGroup
              aria-label="format"
              name="format1"
              value={this.state.channelLayout}
              onChange={(e) => {this.setState({channelLayout:e.target.value})}}
            >
              <FormControlLabel value="4_3" control={<Radio />} label={ETVConstants.trans("4_3")} />
              <FormControlLabel value="3_4" control={<Radio />} label={ETVConstants.trans("3_4")} />
              <FormControlLabel value="16_9" control={<Radio />} label={ETVConstants.trans("16_9")} />
              <FormControlLabel value="9_16" control={<Radio />} label={ETVConstants.trans("9_16")} />
              <FormControlLabel value="5_4" control={<Radio />} label={ETVConstants.trans("5_4")} />
              <FormControlLabel value="4_5" control={<Radio />} label={ETVConstants.trans("4_5")} />
              <FormControlLabel value="191_1" control={<Radio />} label={ETVConstants.trans("191_1")} />
              <FormControlLabel value="1_1" control={<Radio />} label={ETVConstants.trans("square")} />
              <FormControlLabel value="banner" control={<Radio />} label="Banner (468x60)" />
              <FormControlLabel value="leaderboard" control={<Radio />} label="Leaderboard (728x90)" />
              <FormControlLabel value="inline_rectangle" control={<Radio />} label="Inline Rectangle (300x250)" />
              <FormControlLabel value="skyscraper" control={<Radio />} label="Skyscraper (120x600)" />
              <FormControlLabel value="half_page_ad" control={<Radio />} label="Half Page Ad (300x600)" />
              <FormControlLabel value="large_leaderboard" control={<Radio />} label="Large Leaderboard (970x90)" />
              <FormControlLabel value="freestyle" control={<Radio />} label={ETVConstants.trans("freestyle")} />
              <FormControlLabel value="raster" control={<Radio />} label={ETVConstants.trans("raster")} />
            </RadioGroup>
          </FormControl>
        </div>
      );
    }

    getChannelTypeOptions() {
      const general = this.transLabel("general", "General").searchLabel;
      const elevator = this.transLabel("elevator", "Elevator").searchLabel;
      const timeWeather = this.transLabel("time_weather", "Time / Weather").searchLabel;
      const information = this.transLabel("information", "Information").searchLabel;
      const touch = this.transLabel("touch", "Touch").searchLabel;

      const options = [
        {
          group: general,
          value: "content",
          ...this.transLabel("content", "Content"),
          hidden: this.state.curChannel > 4
        },
        {
          group: general,
          value: "streaming",
          ...this.transLabel("ip_streaming", "IP Streaming")
        },

        {
          group: elevator,
          value: "elevator_landscape",
          ...this.transLabel("floor_indicator_landscape", "Floor indicator landscape"),
          hidden: this.state.curElevFrag > 0
        },
        {
          group: elevator,
          value: "elevator_portrait",
          ...this.transLabel("floor_indicator_portrait", "Floor indicator portrait"),
          hidden: this.state.curElevFrag > 0
        },
        {
          group: elevator,
          value: "speed",
          ...this.transLabel("elevator_speed", "Elevator Speed")
        },
        {
          group: elevator,
          value: "speed2",
          ...this.transLabel("elevator_speed_2", "Elevator Speed Circle")
        },

        {
          group: elevator,
          value: "height",
          ...this.transLabel("elevator_height", "Elevator Height")
        },
        {
          group: elevator,
          value: "height2",
          ...this.transLabel("elevator_height2", "Elevator Height2")
        },
        {
          group: elevator,
          value: "arrow",
          ...this.transLabel("arrow", "Arrow")
        },
        {
          group: elevator,
          value: "door",
          ...this.transLabel("door", "Door")
        },
        {
          group: elevator,
          value: "floornumber",
          ...this.transLabel("floornumber", "Floor Number")
        },
        {
          group: elevator,
          value: "next_stop",
          ...this.transLabel("next_stop", "Next Stop")
        },
        {
          group: elevator,
          value: "next_stop_2",
          ...this.transLabel("next_stop_2", "Next Stop 2")
        },
        {
          group: elevator,
          value: "next_stop_3",
          ...this.transLabel("next_stop_3", "Next Stop 3")
        },
        {
          group: elevator,
          value: "next_stop_list",
          ...this.transLabel("next_stop_list", "Next Stop List")
        },
        {
          group: elevator,
          value: "next_stop_list_2",
          ...this.transLabel("next_stop_list_2", "Next Stop List 2")
        },
        {
          group: elevator,
          value: "tripcounter",
          ...this.transLabel("trip_counter", "Trip Counter")
        },
        {
          group: elevator,
          value: "remote_elevator_view",
          ...this.transLabel("remote_elevator_view", "Remote Elevator View")
        },
        {
          group: elevator,
          value: "kone_dcs_queue_message_view",
          ...this.transLabel("kone_dcs_queue_message_view", "KONE DCS Queue Message View")
        },

        {
          group: timeWeather,
          value: "time1",
          ...this.transLabel("time_fragment_simple", "Time Simple")
        },
        {
          group: timeWeather,
          value: "time2",
          ...this.transLabel("time_fragment_2_lines", "Time 2 Lines")
        },
        {
          group: timeWeather,
          value: "time3",
          ...this.transLabel("time_fragment", "Time")
        },
        {
          group: timeWeather,
          value: "time3V2",
          ...this.transLabel("time_fragment_v2", "Time V2")
        },
        {
          group: timeWeather,
          value: "weather",
          ...this.transLabel("current_weather", "Current Weather")
        },
        {
          group: timeWeather,
          value: "weather5",
          ...this.transLabel("weather_forecast", "Weather Forecast")
        },

        {
          group: information,
          value: "floorpics",
          ...this.transLabel("floor_information", "Floor Information")
        },
        {
          group: information,
          value: "floor_directory",
          ...this.transLabel("floor_directory", "Floor Directory")
        },
        {
          group: information,
          value: "floor_directory_noscrolling",
          ...this.transLabel("floor_directory_noscrolling", "Floor Directory No Scrolling")
        },
        {
          group: information,
          value: "statictext",
          ...this.transLabel("static_text", "Static Text")
        },
        {
          group: information,
          value: "qrcode",
          ...this.transLabel("qr_code", "QR Code")
        },

        {
          group: touch,
          value: "elevator_touch_button",
          ...this.transLabel("elevator_touch_button", "Elevator Touch Button")
        },
        {
          group: touch,
          value: "elevator_touch_button_10",
          ...this.transLabel("elevator_touch_button_10", "Elevator Touch Button 10")
        },
        {
          group: touch,
          value: "elevator_touch_button_scrolling",
          ...this.transLabel("elevator_touch_button_scrolling", "Elevator Touch Button Scrolling")
        }
      ];

      return options.filter(option => !option.hidden);
    } 

    getText(value) {
      if (value === null || value === undefined) return "";
      if (typeof value === "string") return value;
      if (typeof value === "number") return String(value);
      return "";
    }

    printChannelTypeChoice() {
      const options = this.getChannelTypeOptions();
      const selectedOption = options.find(
        (option) => option.value === this.state.channel_type
      ) || null;

      return (
        <Autocomplete
          id="channel_type"
          sx={{width:330}}
          options={options}
          value={selectedOption}
          groupBy={(option) => option.group}
          getOptionLabel={(option) => option?.searchLabel || ""}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          renderOption={(props, option) => (
            <li {...props} key={option.value}>
              {option.label}
            </li>
          )}
          onChange={(event, option) => {
            this.handleChannelTypeChange(option ? option.value : "");
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={ETVConstants.trans("channel_type")}
              placeholder={ETVConstants.trans("choose_channel_type")}
              variant="outlined"
            />
          )}
        />
      );
    }

    render() {
      return (
        <Card>
          <CardContent>
            <table><tbody>
              <tr valign='top'>
                <td style={{width:350}}>
                    <span>
                      {this.printChannelTypeChoice()}
                    </span>
                    <br/>
                    <br/>
                    {this.renderChannelTypeSettings()}
                    <br/>
                </td>
                <td>
                     <div>
                        <div>
                            {this.createDeviceResolutionDropDown()}
                            <FormControl style={{marginLeft:20}}>
                                <FormLabel component="legend" style={{marginBottom:10}}>{ETVConstants.trans("background_helper")}</FormLabel>
                                <input type="file" onChange={ (e) => this.loadBG(e.target.files) } style={{ width:200}} />
                            </FormControl>
                          </div>
                          <canvas ref="canvas" width={this.state.cWidth} height={this.state.cHeight} style={{border:"1px solid lightgrey", backgroundColor:'#FDFDFD',marginTop:20}}
                                onClick={this.handleCanvasClick}
                                tabIndex="0"
                                onKeyDown={this.onKeyDown}
                                onMouseOut={this.onMouseOut}
                                onMouseMove={this.onMouseMove} />
                     </div>
                </td>
              </tr>
             </tbody></table>

            <MessageDialog spinning={this.state.spinning} type={this.state.info_type} open={this.state.window==='message_div'} onClose={this.closeInfoMessage} title={this.state.info_title} message={this.state.info_message} />

             <Dialog
   							open={this.state.window==='location_map_div'}
   							onClose={()=>{}}
   							fullWidth={true}
   							maxWidth='xl'
   							scroll='paper'
   							aria-labelledby="alert-dialog-title"
   							aria-describedby="alert-dialog-description">
   							<DialogTitle id="alert-dialog-title">{ETVConstants.trans("select_location")}</DialogTitle>
   							<DialogContent>
   									<div style={{height:800,maxHeight:800}}>
   										{this.state.window==='location_map_div'?<LocationMap lat={this.state.weather_city_lat} lgt={this.state.weather_city_lgt} setLocationGPS={this.setLocationGPS} />:<span/>}
   									</div>
   							</DialogContent>
   							<DialogActions>
   									<Button onClick={()=>{this.setState({window:this.state.selected_group_id<0?'edit_location_div':'edit_group_location_div'})}} color="primary" autoFocus>{ETVConstants.trans("close")}</Button>
   							</DialogActions>
 						</Dialog>

          </CardContent>
          <CardActions>
              {this.state.items.length>0?<Button color="primary" onClick={() => this.stepBack()}>{ETVConstants.trans("back")}</Button>:<span/>}
              <Button color="primary" startIcon={<RestartAlt/>} onClick={() => this.clearChannels()}>{ETVConstants.trans("reset")}</Button>
              {this.state.items.length>0?<Button color="primary" size="small" startIcon={<Upload/>} variant='contained' onClick={() => this.finalize()}>{ETVConstants.trans("upload")}</Button>:<span/>}
          </CardActions>
        </Card>
      )
    }
}

export default LayoutDesigner;
